export enum EIndicatorSource {
  DROPDOWN = 'DROPDOWN',
  CONTEXT_MENU = 'CONTEXT_MENU'
}

export enum EDataTestIdPrefix {
  EDIT = 'EDIT',
  TRADE = 'TRADE',
  EDIT_CONFIRMATION = 'EDIT_CONFIRMATION',
  TRADE_CONFIRMATION = 'TRADE_CONFIRMATION',
  SPECIFICATION = 'SPECIFICATION',
  DROPDOWN_CHART_SETTING = 'DROPDOWN_CHART_SETTING',
  CONTEXT_MENU_CHART_SETTING = 'CONTEXT_MENU_CHART_SETTING',
  CHART_INDICATOR = 'CHART_INDICATOR',
  EDIT_INPUT_EXPIRY_DATE = 'EDIT_INPUT_EXPIRY_DATE',
  TRADE_INPUT_EXPIRY_DATE = 'TRADE_INPUT_EXPIRY_DATE',
  EDIT_INPUT_EXPIRY_TIME = 'EDIT_INPUT_EXPIRY_TIME',
  TRADE_INPUT_EXPIRY_TIME = 'TRADE_INPUT_EXPIRY_TIME',
  TOP_PICKS = 'TOP_PICKS',
  TOP_GAINER = 'TOP_GAINER',
  TOP_LOSER = 'TOP_LOSER',
  WATCHLIST = 'WATCHLIST'
}

export enum EDataTestIdSuffix {
  LABEL = 'LABEL',
  VALUE = 'VALUE',
  SYMBOL = 'SYMBOL',
  ORDER_TYPE = 'ORDER_TYPE',
  ORDER_ID = 'ORDER_ID',
  VOLUME = 'VOLUME',
  BUTTON_CONFIRM = 'BUTTON_CONFIRM',
  BUTTON_CLOSE = 'BUTTON_CLOSE',
  BUTTON_UPDATE_NOW = 'BUTTON_UPDATE_NOW',
  HOUR = 'HOUR',
  MINUTE = 'MINUTE',
  SECOND = 'SECOND',
  CHART_COLOR_SETTING = 'CHART_COLOR_SETTING',
  DROPDOWN_FILL_POLICY = 'DROPDOWN_FILL_POLICY',
  DROPDOWN_EXPIRY = 'DROPDOWN_EXPIRY',
  DROPDOWN_DEVIATION = 'DROPDOWN_DEVIATION',
  REMOVE_ALL_DRAWING = 'REMOVE_ALL_DRAWING',
  REMOVE_ALL_INDICATORS = 'REMOVE_ALL_INDICATORS',
  RESET_CHART = 'RESET_CHART',
  HIDE_ASK_PRICE_ON_Y_AXIS = 'HIDE_ASK_PRICE_ON_Y_AXIS',
  SHOW_ASK_PRICE_ON_Y_AXIS = 'SHOW_ASK_PRICE_ON_Y_AXIS',
  CLEAR_ALL_TRACK_DETAILS = 'CLEAR_ALL_TRACK_DETAILS',
  REMOVE_ALL_INDICATORS_AND_DRAWINGS = 'REMOVE_ALL_INDICATORS_AND_DRAWINGS',
  SHOW_ALL_PRICE_ALERTS = 'SHOW_ALL_PRICE_ALERTS',
  HIDE_ALL_PRICE_ALERTS = 'HIDE_ALL_PRICE_ALERTS',
  ONE_POINT_EQUAL_LABEL = 'ONE_POINT_EQUAL_LABEL',
  MODAL = 'MODAL',

  MARKET = 'MARKET',
  LIMIT = 'LIMIT',
  STOP = 'STOP',
  STOP_LIMIT = 'STOP_LIMIT',

  GTC = 'GOOD_TILL_CANCELED',
  GTD = 'GOOD_TILL_DAY',
  DAY = 'DAY',
  SPECIFIED_DATE = 'SPECIFIED_DATE',
  SPECIFIED_TIMESTAMP = 'SPECIFIED_DATE_AND_TIME',

  FOK = 'FILL_OR_KILL',
  IOC = 'IMMEDIATE_OR_CANCEL',
  RETURN = 'RETURN',

  CLOSE = 'CLOSE',
  TITLE = 'TITLE',
  DESCRIPTION = 'DESCRIPTION',

  INCREASE = 'increase',
  DECREASE = 'decrease',
  STATIC_MIN = 'static-min',
  STATIC_MAX = 'static-max',
  MAX_VALUE = 'max-value'
}

export enum EPricePointsDataTestIdPrefix {
  EDIT_INPUT_STOPLOSS = 'EDIT_INPUT_STOPLOSS',
  EDIT_INPUT_TAKEPROFIT = 'EDIT_INPUT_TAKEPROFIT',
  TRADE_INPUT_TAKEPROFIT = 'TRADE_INPUT_TAKEPROFIT',
  TRADE_INPUT_STOPLOSS = 'TRADE_INPUT_STOPLOSS'
}

export enum EDataTestId {
  APP_SETTING_DROPDOWN_TRIGGER = 'app-setting-dropdown-trigger',

  MODAL_JAILBREAK = 'modal-jailbreak',

  ASSET_VISIBLE = 'asset-visible',
  ASSET_HIDDEN = 'asset-hidden',

  ASSET_ACCOUNT_INFO_ID = 'asset-account-info-id',
  ASSET_ACCOUNT_INFO_LEVERAGE = 'asset-account-info-leverage',
  ASSET_ACCOUNT_INFO_BALANCE = 'asset-account-info-balance',
  ASSET_ACCOUNT_INFO_PNL = 'asset-account-info-pnl',
  ASSET_ACCOUNT_INFO_BUYING_POWER = 'asset-account-info-buying-power',
  ASSET_ACCOUNT_INFO_CREDIT = 'asset-account-info-credit',
  ASSET_ACCOUNT_INFO_DEPOSIT = 'asset-account-info-deposit',
  ASSET_ACCOUNT_INFO_WITHDRAWAL = 'asset-account-info-withdrawal',
  ASSET_AVAILABLE_BALANCE_TITLE = 'available-balance-label',
  ASSET_AVAILABLE_BALANCE_VALUE = 'available-balance-value',
  ASSET_DETAILED_HEADER_SYMBOL = 'asset-detailed-header-symbol',

  ASSET_HISTORY = 'asset-history',
  ASSET_HISTORY_COLUMN_AVG_FILLED_PRICE = 'asset-history-column-avg-filled-price',
  ASSET_HISTORY_COLUMN_CLOSE_CENTROID_ORDER_ID = 'asset-history-column-close-centroid-order-id',
  ASSET_HISTORY_COLUMN_CLOSE_DATE = 'asset-history-column-close-date',
  ASSET_HISTORY_COLUMN_CLOSE_PRICE = 'asset-history-column-close-price',
  ASSET_HISTORY_COLUMN_CLOSED_TRANSACTION_TYPE = 'asset-history-column-closed-transaction-type',
  ASSET_HISTORY_COLUMN_COMMENT = 'asset-history-column-comment',
  ASSET_HISTORY_COLUMN_COMMISSION = 'asset-history-column-commission',
  ASSET_HISTORY_COLUMN_CREATED_DATE = 'asset-history-column-created-date',
  ASSET_HISTORY_COLUMN_CURRENCY = 'asset-history-column-currency',
  ASSET_HISTORY_COLUMN_ENTRY_PRICE = 'asset-history-column-entry-price',
  ASSET_HISTORY_COLUMN_EXPIRY_DATE = 'asset-history-column-expiry-date',
  ASSET_HISTORY_COLUMN_FILL_POLICY = 'asset-history-column-fill-policy',
  ASSET_HISTORY_COLUMN_FILL_VOLUME = 'asset-history-column-fill-volume',
  ASSET_HISTORY_COLUMN_FILLED_QUANTITY = 'asset-history-column-filled-quantity',
  ASSET_HISTORY_COLUMN_LIMIT_PRICE = 'asset-history-column-limit-price',
  ASSET_HISTORY_COLUMN_MARKET_RANGE = 'asset-history-column-market-range',
  ASSET_HISTORY_COLUMN_NOTIONAL = 'asset-history-column-notional',
  ASSET_HISTORY_COLUMN_OPEN_CENTROID_ORDER_ID = 'asset-history-column-open-centroid-order-id',
  ASSET_HISTORY_COLUMN_OPEN_DATE = 'asset-history-column-open-date',
  ASSET_HISTORY_COLUMN_ORDER_ID = 'asset-history-column-order-id',
  ASSET_HISTORY_COLUMN_ORDER_STATUS = 'asset-history-column-order-status',
  ASSET_HISTORY_COLUMN_ORDER_TYPE = 'asset-history-column-order-type',
  ASSET_HISTORY_COLUMN_PLACED_QUANTITY = 'asset-history-column-placed-quantity',
  ASSET_HISTORY_COLUMN_PRICE = 'asset-history-column-price',
  ASSET_HISTORY_COLUMN_PROFIT = 'asset-history-column-profit',
  ASSET_HISTORY_COLUMN_REMAINING_QUANTITY = 'asset-history-column-remaining-quantity',
  ASSET_HISTORY_COLUMN_REMARKS = 'asset-history-column-remarks',
  ASSET_HISTORY_COLUMN_SIZE = 'asset-history-column-size',
  ASSET_HISTORY_COLUMN_STATE = 'asset-history-column-state',
  ASSET_HISTORY_COLUMN_STATUS = 'asset-history-column-status',
  ASSET_HISTORY_COLUMN_STOP_LOSS = 'asset-history-column-stop-loss',
  ASSET_HISTORY_COLUMN_STOP_PRICE = 'asset-history-column-stop-price',
  ASSET_HISTORY_COLUMN_SWAP = 'asset-history-column-swap',
  ASSET_HISTORY_COLUMN_SYMBOL = 'asset-history-column-symbol',
  ASSET_HISTORY_COLUMN_SYMBOL_NAME = 'asset-history-column-symbol-name',
  ASSET_HISTORY_COLUMN_TAKE_PROFIT = 'asset-history-column-take-profit',
  ASSET_HISTORY_COLUMN_TICKET = 'asset-history-column-ticket',
  ASSET_HISTORY_COLUMN_TIME_IN_FORCE = 'asset-history-column-time-in-force',
  ASSET_HISTORY_COLUMN_UNITS = 'asset-history-column-units',
  ASSET_HISTORY_COLUMN_UPDATED_DATE = 'asset-history-column-updated-date',
  ASSET_HISTORY_COLUMN_VALIDITY = 'asset-history-column-validity',
  ASSET_HISTORY_COLUMN_VOLUME = 'asset-history-column-volume',
  ASSET_HISTORY_COLUMN_FILLED_VOLUME = 'asset-history-column-filled-volume',
  ASSET_HISTORY_POSITION_LIST = 'asset-history-position-list',
  ASSET_HISTORY_POSITION_LIST_ITEM = 'asset-history-position-list-item',
  ASSET_HISTORY_POSITION_LIST_ITEM_EXPAND = 'asset-history-position-list-item-expand',
  ASSET_HISTORY_POSITION_TABLE = 'asset-history-position-table',
  ASSET_HISTORY_POSITION_TABLE_HEADER = 'asset-history-position-table-header',

  ASSET_HISTORY_ORDER_DEAL = 'asset-history-order-deal',
  ASSET_HISTORY_ORDER_DEAL_TABLE = 'asset-history-order-deal-table',
  ASSET_HISTORY_ORDER_DEAL_TABLE_HEADER = 'asset-history-order-deal-table-header',
  ASSET_HISTORY_ORDER_DEAL_LIST = 'asset-history-order-deal-list',
  ASSET_HISTORY_ORDER_DEAL_COLUMN_CLOSE_DATE = 'asset-history-order-deal-column-close-date',
  ASSET_HISTORY_ORDER_DEAL_COLUMN_CLOSE_PRICE = 'asset-history-order-deal-column-close-price',
  ASSET_HISTORY_ORDER_DEAL_COLUMN_COMMISSION = 'asset-history-order-deal-column-commission',
  ASSET_HISTORY_ORDER_DEAL_COLUMN_ENTRY_PRICE = 'asset-history-order-deal-column-entry-price',
  ASSET_HISTORY_ORDER_DEAL_COLUMN_OPEN_DATE = 'asset-history-order-deal-column-open-date',
  ASSET_HISTORY_ORDER_DEAL_COLUMN_ORDER_ID = 'asset-history-order-deal-column-order-id',
  ASSET_HISTORY_ORDER_DEAL_COLUMN_ORDER_TYPE = 'asset-history-order-deal-column-order-type',
  ASSET_HISTORY_ORDER_DEAL_COLUMN_PROFIT = 'asset-history-order-deal-column-profit',
  ASSET_HISTORY_ORDER_DEAL_COLUMN_REMARKS = 'asset-history-order-deal-column-remarks',
  ASSET_HISTORY_ORDER_DEAL_COLUMN_SIZE = 'asset-history-order-deal-column-size',
  ASSET_HISTORY_ORDER_DEAL_COLUMN_STATUS = 'asset-history-order-deal-column-status',
  ASSET_HISTORY_ORDER_DEAL_COLUMN_STOP_LOSS = 'asset-history-order-deal-column-stop-loss',
  ASSET_HISTORY_ORDER_DEAL_COLUMN_SWAP = 'asset-history-order-deal-column-swap',
  ASSET_HISTORY_ORDER_DEAL_COLUMN_TAKE_PROFIT = 'asset-history-order-deal-column-take-profit',
  ASSET_HISTORY_ORDER_DEAL_COLUMN_UNITS = 'asset-history-order-deal-column-units',
  ASSET_HISTORY_ORDER_DEAL_COLUMN_FILL_POLICY = 'asset-history-order-deal-column-fill-policy',

  ASSET_OPEN = 'asset-open',
  ASSET_OPEN_BUTTON_CLOSE = 'asset-open-button-close',
  ASSET_OPEN_BUTTON_EDIT = 'asset-open-button-edit',
  ASSET_OPEN_BUTTON_TRACK = 'asset-open-button-track',
  ASSET_OPEN_BUTTON_DETAILS = 'asset-open-button-details',
  ASSET_OPEN_COLUMN_AVG_BOUGHT_PRICE = 'asset-open-column-avg-bought-price',
  ASSET_OPEN_COLUMN_AVG_ENTRY_POINT = 'asset-open-column-avg-entry-point',
  ASSET_OPEN_COLUMN_AVG_SOLD_PRICE = 'asset-open-column-avg-sold-price',
  ASSET_OPEN_COLUMN_CLOSE_PRICE = 'asset-open-column-close-price',
  ASSET_OPEN_COLUMN_COMMISSION = 'asset-open-column-commission',
  ASSET_OPEN_COLUMN_CURRENT_PRICE = 'asset-open-column-current-price',
  ASSET_OPEN_COLUMN_ENTRY_PRICE = 'asset-open-column-entry-price',
  ASSET_OPEN_COLUMN_MARGIN = 'asset-open-column-margin',
  ASSET_OPEN_COLUMN_MARKET_VALUE = 'asset-open-column-market-value',
  ASSET_OPEN_COLUMN_NOTIONAL = 'asset-open-column-notional',
  ASSET_OPEN_COLUMN_OPEN_DATE = 'asset-open-column-open-date',
  ASSET_OPEN_COLUMN_ORDER_ID = 'asset-open-column-order-id',
  ASSET_OPEN_COLUMN_ORDER_TYPE = 'asset-open-column-order-type',
  ASSET_OPEN_COLUMN_POTENTIAL_GAIN = 'asset-open-column-potential-gain',
  ASSET_OPEN_COLUMN_POTENTIAL_LOSS = 'asset-open-column-potential-loss',
  ASSET_OPEN_COLUMN_PROFIT = 'asset-open-column-profit',
  ASSET_OPEN_COLUMN_RISK_REWARD = 'asset-open-column-risk-reward',
  ASSET_OPEN_COLUMN_STOP_LOSS = 'asset-open-column-stop-loss',
  ASSET_OPEN_COLUMN_STOP_LOSS_IN_POINTS = 'asset-open-column-stop-loss-in-points',
  ASSET_OPEN_COLUMN_SWAP = 'asset-open-column-swap',
  ASSET_OPEN_COLUMN_SYMBOL = 'asset-open-column-symbol',
  ASSET_OPEN_COLUMN_TAKE_PROFIT = 'asset-open-column-take-profit',
  ASSET_OPEN_COLUMN_UNITS = 'asset-open-column-units',
  ASSET_OPEN_COLUMN_VOLUME = 'asset-open-column-volume',
  ASSET_OPEN_COLUMN_ORDER_STATUS = 'asset-open-column-order-status',
  ASSET_OPEN_COLUMN_COMMENT = 'asset-open-column-comment',
  ASSET_OPEN_LIST = 'asset-open-list',
  ASSET_OPEN_LIST_ITEM = 'asset-open-list-item',
  ASSET_OPEN_LIST_ITEM_EXPAND = 'asset-open-list-item-expand',
  ASSET_OPEN_LIST_ITEM_ORDER_NO = 'asset-open-list-item-order-no',
  ASSET_OPEN_TABLE = 'asset-open-table',
  ASSET_OPEN_TABLE_HEADER = 'asset-open-table-header',

  ASSET_SPECIFICATION_ITEM_EXPAND = 'asset-specification-item-expand',

  ASSET_HEADER_VIEW_ALL = 'asset-header-view-all',

  ASSET_COPY_TRADE_MISSED_TRADES_COLUMN_MISSED_DATE = 'asset-copy-trade-missed-trades-column-missed-date',
  ASSET_COPY_TRADE_MISSED_TRADES_COLUMN_ORDER_NO = 'asset-copy-trade-missed-trades-column-order-no',
  ASSET_COPY_TRADE_MISSED_TRADES_COLUMN_STRATEGY_NAME = 'asset-copy-trade-missed-trades-column-strategy-name',
  ASSET_COPY_TRADE_MISSED_TRADES_COLUMN_REASON = 'asset-copy-trade-missed-trades-column-reason',
  ASSET_COPY_TRADE_MISSED_TRADES_LIST_ITEM = 'asset-copy-trade-missed-trades-list-item',

  ASSET_ORDER_TYPE = 'asset-order-type',
  TAB_ASSET_SPECIFICATION = 'tab-asset-specification',
  TAB_ASSET_ORDER_TYPE_OPEN_POSITIONS = 'tab-asset-order-type-open-positions',
  TAB_ASSET_ORDER_TYPE_PENDING_ORDERS = 'tab-asset-order-type-pending-orders',
  TAB_ASSET_ORDER_TYPE_HISTORY = 'tab-asset-order-type-history',
  TAB_ASSET_ORDER_TYPE_HISTORY_POSITIONS_HISTORY = 'tab-asset-order-type-history-positions-history',
  TAB_ASSET_ORDER_TYPE_HISTORY_ORDERS_AND_DEALS = 'tab-asset-order-type-history-orders-and-deals',
  TAB_ASSET_ORDER_TYPE_HISTORY_CENTROID = 'tab-asset-order-type-history-centroid',

  ASSET_PENDING = 'asset-pending',
  ASSET_PENDING_BUTTON_CLOSE = 'asset-pending-button-close',
  ASSET_PENDING_BUTTON_EDIT = 'asset-pending-button-edit',
  ASSET_PENDING_BUTTON_TRACK = 'asset-pending-button-track',
  ASSET_PENDING_COLUMN_CURRENT_PRICE = 'asset-pending-column-current-price',
  ASSET_PENDING_COLUMN_ENTRY_PRICE = 'asset-pending-column-entry-price',
  ASSET_PENDING_COLUMN_EXPIRY = 'asset-pending-column-expiry',
  ASSET_PENDING_COLUMN_EXPIRY_DATE = 'asset-pending-column-expiry-date',
  ASSET_PENDING_COLUMN_FILL_POLICY = 'asset-pending-column-fill-policy',
  ASSET_PENDING_COLUMN_FILL_VOLUME = 'asset-pending-column-fill-volume',
  ASSET_PENDING_COLUMN_FILLED_QUANTITY = 'asset-pending-column-filled-quantity',
  ASSET_PENDING_COLUMN_LAST_PRICE = 'asset-pending-column-last-price',
  ASSET_PENDING_COLUMN_LIMIT_PRICE = 'asset-pending-column-limit-price',
  ASSET_PENDING_COLUMN_MARKET_PRICE = 'asset-pending-column-market-price',
  ASSET_PENDING_COLUMN_MARKET_RANGE = 'asset-pending-column-market-range',
  ASSET_PENDING_COLUMN_OPEN_DATE = 'asset-pending-column-open-date',
  ASSET_PENDING_COLUMN_ORDER_ID = 'asset-pending-column-order-id',
  ASSET_PENDING_COLUMN_ORDER_STATUS = 'asset-pending-column-order-status',
  ASSET_PENDING_COLUMN_ORDER_TYPE = 'asset-pending-column-order-type',
  ASSET_PENDING_COLUMN_PENDING_PRICE = 'asset-pending-column-pending-price',
  ASSET_PENDING_COLUMN_PLACED_QUANTITY = 'asset-pending-column-placed-quantity',
  ASSET_PENDING_COLUMN_PRICE = 'asset-pending-column-price',
  ASSET_PENDING_COLUMN_REMAINING_QUANTITY = 'asset-pending-column-remaining-quantity',
  ASSET_PENDING_COLUMN_STOP_LIMIT_PRICE = 'asset-pending-column-stop-limit-price',
  ASSET_PENDING_COLUMN_STOP_LOSS = 'asset-pending-column-stop-loss',
  ASSET_PENDING_COLUMN_STOP_PRICE = 'asset-pending-column-stop-price',
  ASSET_PENDING_COLUMN_SYMBOL = 'asset-pending-column-symbol',
  ASSET_PENDING_COLUMN_TAKE_PROFIT = 'asset-pending-column-take-profit',
  ASSET_PENDING_COLUMN_TIME_IN_FORCE = 'asset-pending-column-time-in-force',
  ASSET_PENDING_COLUMN_UNITS = 'asset-pending-column-units',
  ASSET_PENDING_COLUMN_VOLUME = 'asset-pending-column-volume',
  ASSET_PENDING_LIST = 'asset-pending-list',
  ASSET_PENDING_LIST_ITEM = 'asset-pending-list-item',
  ASSET_PENDING_LIST_ITEM_EXPAND = 'asset-pending-list-item-expand',
  ASSET_PENDING_LIST_ITEM_ORDER_NO = 'asset-pending-list-item-order-no',
  ASSET_PENDING_TABLE = 'asset-pending-table',
  ASSET_PENDING_TABLE_HEADER = 'asset-pending-table-header',
  ASSET_PENDING_CLOSE_MODAL_PRICE = 'asset-pending-close-modal-price',
  ASSET_PENDING_CLOSE_MODAL_STOP_LOSS = 'asset-pending-close-modal-stop-loss',
  ASSET_PENDING_CLOSE_MODAL_TAKE_PROFIT = 'asset-pending-close-modal-take-profit',
  ASSET_PENDING_CLOSE_MODAL_STOP_LIMIT_PRICE = 'asset-pending-close-modal-stop-limit-price',
  ASSET_PENDING_CLOSE_MODAL_OPENDATE = 'asset-pending-close-modal-opendate',
  ASSET_PENDING_CLOSE_MODAL_EXPIRY = 'asset-pending-close-modal-expiry',
  ASSET_PENDING_CLOSE_MODAL_UNITS = 'asset-pending-close-modal-units',
  ASSET_PENDING_CLOSE_MODAL_VOLUME = 'asset-pending-close-modal-volume',
  ASSET_PENDING_CLOSE_MODAL_BUTTON_CONFIRM = 'asset-pending-close-modal-button-confirm',
  ASSET_PENDING_CLOSE_MODAL_BUTTON_CANCEL = 'asset-pending-close-modal-button-cancel',

  ASSETS_INSIGHTS_BUTTON = 'assets-insights-button',
  ASSETS_CHART_EMPTY = 'assets-chart-empty',
  ASSETS_TRADE_EMPTY = 'assets-trade-empty',
  ASSETS_SEARCH_INPUT = 'assets-search-input',
  ASSETS_CANCEL_SEARCH_BUTTON = 'assets-cancel-search-button',

  ASSET_CLOSE_ORDER_CONFIRMATION_INPUT_VOLUME = 'asset-open-close-modal-input-volume',
  ASSET_CLOSE_ORDER_CONFIRMATION_VOLUME_FORMITEM = 'asset-open-close-modal-volume-formitem',
  ASSET_CLOSE_ORDER_CONFIRMATION_MIN_VOLUME_BUTTON = 'asset-close-order-confirmation-min-volume-button',
  ASSET_CLOSE_ORDER_CONFIRMATION_MAX_VOLUME_BUTTON = 'asset-close-order-confirmation-max-volume-button',
  ASSET_CLOSE_ORDER_CONFIRMATION_25_PERCENT_VOLUME_BUTTON = 'asset-close-order-confirmation-25-percent-volume-button',
  ASSET_CLOSE_ORDER_CONFIRMATION_75_PERCENT_VOLUME_BUTTON = 'asset-close-order-confirmation-75-percent-volume-button',
  ASSET_CLOSE_ORDER_CONFIRMATION_CLOSE_ORDER_BUTTON = 'asset-close-order-confirmation-close-order-button',
  ASSET_CLOSE_ORDER_CONFIRMATION_BUTTON = 'asset-close-order-confirmation-button',
  ASSET_CLOSE_ORDER_CONFIRMATION_EXPIRATION = 'asset-close-order-confirmation-expiration',
  ASSET_CLOSE_ORDER_CONFIRMATION_FILL_POLICY = 'asset-close-order-confirmation-fill-policy',
  ASSET_CLOSE_ORDER_CONFIRMATION_EXPIRATION_FORMITEM = 'asset-close-order-confirmation-expiration-formitem',
  ASSET_CLOSE_ORDER_CONFIRMATION_FILL_POLICY_FORMITEM = 'asset-close-order-confirmation-fill-policy-formitem',

  ASSET_FILTER_BUTTON = 'asset-filter-button',
  ASSET_FILTER_SORT_RADIO_LATEST = 'asset-filter-sort-radio-latest',
  ASSET_FILTER_SORT_RADIO_OLDEST = 'asset-filter-sort-radio-oldest',
  ASSET_FILTER_SORT_RADIO_A_Z = 'asset-filter-sort-radio-a-z',
  ASSET_FILTER_SORT_RADIO_Z_A = 'asset-filter-sort-radio-z-a',
  ASSET_FILTER_SORT_RADIO_PROFIT_LOSS_ASCENDING = 'asset-filter-sort-radio-profit-loss-ascending',
  ASSET_FILTER_SORT_RADIO_PROFIT_LOSS_DESCENDING = 'asset-filter-sort-radio-profit-loss-descending',
  ASSET_FILTER_ORDER_TYPE_BUTTON = 'asset-filter-order-type-button',
  ASSET_FILTER_ORDER_TYPE_BUTTON_ALL = 'asset-filter-order-type-radio-all',
  ASSET_FILTER_ORDER_TYPE_BUTTON_BUY = 'asset-filter-order-type-radio-buy',
  ASSET_FILTER_ORDER_TYPE_BUTTON_SELL = 'asset-filter-order-type-radio-sell',
  ASSET_FILTER_ORDER_STATE = 'asset-filter-order-state',
  ASSET_FILTER_BUTTON_FILTER_ASSET_TYPE = 'asset-filter-button-filter-asset-type',
  ASSET_FILTER_BUTTON_FILTER_ORDER_TYPE = 'asset-filter-button-filter-order-type',
  ASSET_FILTER_BUTTON_FILTER_ORDER_STATUS = 'asset-filter-button-filter-order-status',
  ASSET_FILTER_BUTTON_FILTER_DATE_RANGE = 'asset-filter-button-filter-date-range',
  ASSET_FILTER_BUTTON_CLEAR_ALL = 'asset-filter-button-clear-all',
  ASSET_FILTER_BUTTON_APPLY = 'asset-filter-button-apply',
  ASSET_FILTER_ASSET_TYPE_BUTTON_RESET = 'asset-filter-asset-type-button-reset',
  ASSET_FILTER_ORDER_TYPE_BUTTON_RESET = 'asset-filter-order-type-button-reset',
  ASSET_FILTER_DATE_RANGE_BUTTON_RESET = 'asset-filter-date-range-button-reset',
  ASSET_FILTER_ASSET_TYPE_BUTTON_CONFIRM = 'asset-filter-asset-type-button-confirm',
  ASSET_FILTER_ORDER_TYPE_BUTTON_CONFIRM = 'asset-filter-order-type-button-confirm',
  ASSET_FILTER_DATE_RANGE_BUTTON_CONFIRM = 'asset-filter-date-range-button-confirm',
  ASSET_FILTER_DATE_RANGE_BUTTON_ALL = 'asset-filter-date-range-button-all',
  ASSET_FILTER_DATE_RANGE_BUTTON_LAST_7_DAYS = 'asset-filter-date-range-button-last-7-days',
  ASSET_FILTER_DATE_RANGE_BUTTON_LAST_30_DAYS = 'asset-filter-date-range-button-last-30-days',
  ASSET_FILTER_DATE_RANGE_BUTTON_LAST_90_DAYS = 'asset-filter-date-range-button-last-90-days',
  ASSET_FILTER_DATE_RANGE_BUTTON_THIS_YEAR = 'asset-filter-date-range-button-this-year',
  ASSET_FILTER_DATE_RANGE_BUTTON_LAST_YEAR = 'asset-filter-date-range-button-last-year',
  ASSET_FILTER_DATE_RANGE_BUTTON_CUSTOM = 'asset-filter-date-range-button-custom',
  ASSET_FILTER_ASSET_TYPE_BUTTON_FOREX = 'asset-filter-asset-type-button-forex',
  ASSET_FILTER_ASSET_TYPE_BUTTON_SHARE = 'asset-filter-asset-type-button-shares',
  ASSET_FILTER_ASSET_TYPE_BUTTON_COM = 'asset-filter-asset-type-button-commodities',
  ASSET_FILTER_ASSET_TYPE_BUTTON_INDEX = 'asset-filter-asset-type-button-index',
  ASSET_FILTER_ASSET_TYPE_BUTTON_CRYPTO = 'asset-filter-asset-type-button-crypto',
  ASSET_FILTER_ASSET_TYPE_BUTTON_OTHER = 'asset-filter-asset-type-button-other',
  ASSET_FILTER_ASSET_TYPE_BUTTON_FUTURES = 'asset-filter-asset-type-button-futures',
  ASSET_FILTER_ASSET_TYPE_BUTTON_OPTION = 'asset-filter-asset-type-button-option',
  ASSET_FILTER_ASSET_TYPE_BUTTON_EQUITIES = 'asset-filter-asset-type-button-equities',
  ASSET_FILTER_ASSET_TYPE_BUTTON_ETF = 'asset-filter-asset-type-button-etf',
  ASSET_FILTER_ASSET_TYPE_BUTTON_ALL = 'asset-filter-asset-type-button-all',
  ASSET_BULK_CLOSE_BUTTON = 'asset-bulk-close-button',
  ASSET_BULK_DELETE_BUTTON = 'asset-bulk-delete-button',
  ASSET_BULK_CLOSE_MODAL = 'asset-bulk-close-modal',
  ASSET_BULK_DELETE_MODAL = 'asset-bulk-delete-modal',
  ASSET_BULK_CLOSE_MODAL_CONFIRM = 'asset-bulk-close-modal-confirm',
  ASSET_BULK_DELETE_MODAL_CONFIRM = 'asset-bulk-delete-modal-confirm',
  ASSET_BULK_CLOSE_BUTTON_OPTION_ALL = 'asset-bulk-close-button-option-all',
  ASSET_BULK_CLOSE_BUTTON_OPTION_LOSS = 'asset-bulk-close-button-option-loss',
  ASSET_BULK_CLOSE_BUTTON_OPTION_PROFIT = 'asset-bulk-close-button-option-profit',
  ASSET_BULK_DELETE_BUTTON_OPTION_ALL = 'asset-bulk-delete-button-option-all',
  ASSET_BULK_DELETE_BUTTON_OPTION_LIMIT = 'asset-bulk-delete-button-option-limit',
  ASSET_BULK_DELETE_BUTTON_OPTION_STOP = 'asset-bulk-delete-button-option-stop',
  ASSET_BULK_DELETE_BUTTON_OPTION_STOP_LIMIT = 'asset-bulk-delete-button-option-stop-limit',

  ALPHABET_LIST_PICKER_BOTTOM_SHEET = 'alphabet-list-picker-bottom-sheet',

  PNL_CHART_EMPTY = 'pnl-chart-empty',

  EDIT_STATIC_ENTRY_PRICE = 'edit-static-entry-price',
  EDIT_ENTRY_PRICE = 'edit-entry-price',
  EDIT_STATIC_VOLUME = 'edit-static-volume',
  EDIT_VOLUME = 'edit-volume',
  EDIT_STATIC_UNITS = 'edit-static-units',
  EDIT_UNITS = 'edit-units',
  EDIT_SYMBOL_PRICE = 'edit-symbol-price',
  EDIT_SYMBOL_VALUE = 'edit-symbol-value',
  EDIT_ORDER_ID_LABEL = 'edit-order-id-label',
  EDIT_ORDER_ID_VALUE = 'edit-order-id-value',
  EDIT_ORDER_TYPE_VALUE = 'edit-order-type-value',
  EDIT_INPUT_PRICE = 'edit-input-price',
  EDIT_INPUT_STOP_LIMIT_PRICE = 'edit-input-stop-limit-price',
  EDIT_INPUT_TAKEPROFIT_POINTS = 'edit-input-takeprofit-points',
  EDIT_INPUT_STOPLOSS_POINTS = 'edit-input-stoploss-points',
  EDIT_INPUT_TAKEPROFIT_PRICE = 'edit-input-takeprofit-price',
  EDIT_INPUT_STOPLOSS_PRICE = 'edit-input-stoploss-price',
  EDIT_BUTTON_CANCEL = 'edit-button-cancel',
  EDIT_BUTTON_ORDER = 'edit-button-order',
  EDIT_DROPDOWN_EXPIRY = 'edit-dropdown-expiry',
  EDIT_DROPDOWN_EXPIRY_GOOD_TILL_CANCELLED = 'edit-dropdown-expiry-good-till-cancelled',
  EDIT_DROPDOWN_EXPIRY_GOOD_TILL_DAY = 'edit-dropdown-expiry-good-till-day',
  EDIT_DROPDOWN_EXPIRY_SPECIFIED_DATE = 'edit-dropdown-expiry-specified_date',
  EDIT_DROPDOWN_EXPIRY_SPECIFIED_DATE_AND_TIME = 'edit-dropdown-expiry-specified-date-and-time',
  EDIT_DROPDOWN_FILL_POLICY = 'edit-dropdown-fill-policy',
  EDIT_FILL_POLICY = 'edit-fill-policy',
  EDIT_DROPDOWN_FILL_POLICY_FILL_OR_KILL = 'edit-dropdown-fill-policy-fill-or-kilL',
  EDIT_DROPDOWN_FILL_POLICY_IMMEDIATE_OR_CANCEL = 'edit-dropdown-fill-policy-fill-or-kilL',
  EDIT_DROPDOWN_FILL_POLICY_RETURN = 'edit-dropdown-fill-policy-fill-or-kilL',
  TRADE_DROPDOWN_FILL_POLICY_FILL_OR_KILL = 'trade-dropdown-fill-policy-fill-or-kilL',
  TRADE_DROPDOWN_FILL_POLICY_IMMEDIATE_OR_CANCEL = 'trade-dropdown-fill-policy-fill-or-kilL',
  TRADE_DROPDOWN_FILL_POLICY_RETURN = 'trade-dropdown-fill-policy-fill-or-kilL',
  EDIT_DROPDOWN_DEVIATION = 'edit-dropdown-deviation',

  EDIT_CONFIRMATION_MODAL = 'edit-confirmation-modal',
  EDIT_CONFIRMATION_BUTTON_CONFIRM = 'edit-confirmation-button-confirm',
  EDIT_CONFIRMATION_BUTTON_CLOSE = 'edit-confirmation-button-close',
  EDIT_CONFIRMATION_SYMBOL = 'edit-confirmation-symbol',
  EDIT_CONFIRMATION_ORDER_ID = 'edit-confirmation-order-id',
  EDIT_CONFIRMATION_ORDER_TYPE = 'edit-confirmation-order-type',
  EDIT_CONFIRMATION_LABEL = 'edit-confirmation-label',
  EDIT_CONFIRMATION_VALUE = 'edit-confirmation-value',

  CLOSE_ORDER_BUTTON_SUBMIT = 'close-order-button-submit',
  CLOSE_ORDER_INPUT_VOLUME = 'close-order-input-volume',
  CLOSE_ORDER_INPUT_VOLUME_STATIC_MIN = 'close-order-input-volume-static-min',
  CLOSE_ORDER_INPUT_VOLUME_STATIC_MAX = 'close-order-input-volume-static-max',
  CLOSE_ORDER_BUTTON_CANCEL = 'close-order-button-cancel',
  CLOSE_ORDER_DROPDOWN_FILL_POLICY = 'close-order-dropdown-fill-policy',
  CLOSE_ORDER_SELECTOR = 'close-order-selector',
  CLOSE_PENDING_ORDER_SELECTOR = 'close-pending-order-selector',

  BULK_CLOSE_MODAL_BUTTON_SUBMIT_ALL = 'bulk-close-modal-button-submit-all',
  BULK_CLOSE_MODAL_BUTTON_CANCEL_ALL = 'bulk-close-modal-button-cancel-all',
  BULK_CLOSE_MODAL_BUTTON_CANCEL_LOSS = 'bulk-close-modal-button-cancel-loss',
  BULK_CLOSE_MODAL_BUTTON_CANCEL_PROFIT = 'bulk-close-modal-button-cancel-profit',
  BULK_CLOSE_MODAL_BUTTON_SUBMIT_LOSS = 'bulk-close-modal-button-submit-loss',
  BULK_CLOSE_MODAL_BUTTON_SUBMIT_PROFIT = 'bulk-close-modal-button-submit-profit',
  BULK_DELETE_MODAL_BUTTON_SUBMIT = 'bulk-delete-modal-button-submit',
  BULK_DELETE_MODAL_BUTTON_CANCEL = 'bulk-delete-modal-button-cancel',
  BULK_CLOSE = 'bulk-close',
  BULK_DELETE = 'bulk-delete',
  DROPDOWN_BULK_CLOSE = 'dropdown-bulk-close',
  DROPDOWN_BULK_CLOSE_ALL = 'dropdown-bulk-close-all',
  DROPDOWN_BULK_CLOSE_LOSS = 'dropdown-bulk-close-loss',
  DROPDOWN_BULK_CLOSE_PROFIT = 'dropdown-bulk-close-profit',

  HIDE_OTHER_SYMBOLS_BUTTON = 'hide-other-symbols-button',
  HIDE_OTHER_SYMBOLS_BUTTON_CHECKED = 'hide-other-symbols-button-checked',

  TOGGLE_OCT = 'toggle-oct',
  TOGGLE_OCT_CHECKED = 'toggle-oct-checked',

  TAB_ONE_CLICK_TRADING = 'tab-one-click-trading',
  TAB_TRADE = 'tab-trade',
  TAB_SPECIFICATION = 'tab-specification',

  LANGUAGE_DROPDOWN = 'language-dropdown',
  LANGUAGE_OPTION = 'language-option',

  LOGIN_ACCOUNT_SIGNUP = 'login-account-signup',
  LOGIN_ACCOUNT_TYPE = 'login-account-type',
  LOGIN_PASSWORD = 'login-password',
  LOGIN_SUBMIT = 'login-submit',
  LOGIN_USER_ID = 'login-user-id',
  LOGIN_COMPANY_LOGO = 'login-company-logo',
  LOGIN_BIOMETRICS_FACE_ID = 'login-biometrics-face-id',
  LOGIN_BIOMETRICS_FINGERPRINT = 'login-biometrics-fingerprint',
  TAB_LOGIN_ACCOUNT_TYPE_DEMO = 'tab-login-account-type-demo',
  TAB_LOGIN_ACCOUNT_TYPE_LIVE = 'tab-login-account-type-live',
  TAB_LOGIN_ACCOUNT_TYPE_CRM = 'tab-login-account-type-crm',
  FORGOT_PASSWORD_BUTTON = 'forgot-password-button',
  LOGIN_REMEMBER_ME_CHECKED = 'login-remember-me-checked',
  LOGIN_REMEMBER_ME_UNCHECKED = 'login-remember-me-unchecked',

  NOTIFICATION_BOX = 'notification-box',
  NOTIFICATION_BOX_TITLE = 'notification-box-title',
  NOTIFICATION_BOX_DESCRIPTION = 'notification-box-description',
  NOTIFICATION_BOX_CLOSE = 'notification-box-close',
  NOTIFICATION_DESCRIPTION = 'notification-description',
  NOTIFICATION_DROPDOWN_RESULT = 'notification-dropdown-result',
  NOTIFICATION_LIST_RESULT = 'notification-list-result',
  NOTIFICATION_LIST_RESULT_ITEM = 'notification-list-result-item',
  NOTIFICATION_LIST_RESULT_ITEM_TITLE = 'notification-list-result-item-title',
  NOTIFICATION_LIST_RESULT_ITEM_META = 'notification-list-result-item-meta',
  NOTIFICATION_LIST_RESULT_ITEM_ORDER_NO = 'notification-list-result-item-order-no',
  NOTIFICATION_LIST_RESULT_ITEM_DESCRIPTION = 'notification-list-result-item-description',
  NOTIFICATION_SELECTOR = 'notification-selector',
  NOTIFICATION_TITLE = 'notification-title',
  NOTIFICATION_TYPE = 'notification-type',
  NOTIFICATION_BACK_BUTTON = 'notification-back-button',
  NOTIFICATION_CLOSE_BUTTON = 'notification-close-button',
  NOTIFICATION_TIMING_DROPDOWN = 'notification-timing-dropdown',
  NOTIFICATION_TIMING_OPTION = 'notification-timing-option',
  NOTIFICATION_TIMING_BUTTON_RESET = 'notification-timing-button-reset',
  NOTIFICATION_TIMING_BUTTON_CONFIRM = 'notification-timing-button-confirm',
  NOTIFICATION_TIMING_BOTTOM_SHEET = 'notification-timing-bottom-sheet',

  NOTIFICATION_ORDER_DETAILS_LABEL = 'notification-order-details-label',
  NOTIFICATION_ORDER_DETAILS_VALUE = 'notification-order-details-value',
  NOTIFICATION_ORDER_DETAILS_MODAL_ORDER_TYPE = 'notification-order-details-modal-order-type',
  NOTIFICATION_ORDER_DETAILS_MODAL_CLOSE = 'notification-order-details-modal-close',
  NOTIFICATION_ORDER_DETAILS_MODAL = 'notification-order-details-modal',

  NOTIFICATION_MASK_ALL_AS_READ_BUTTON = 'notification-mask-all-as-read-button',
  NOTIFICATION_BACK_TO_TOP_BUTTON = 'notification-back-to-top-button',

  TAB_NOTIFICATION_TYPE_ALL = 'tab-notification-type-all',
  TAB_NOTIFICATION_TYPE_ORDER = 'tab-notification-type-order',
  TAB_NOTIFICATION_TYPE_SYSTEM = 'tab-notification-type-system',
  TAB_NOTIFICATION_TYPE_INFORMATION = 'tab-notification-type-information',
  TAB_NOTIFICATION_TYPE_PRICE_ALERT = 'tab-notification-type-price-alert',

  CHART_TRADE_BUTTON = 'chart-trade-button',
  CHART_STAR_SYMBOL = 'chart-star-symbol',
  CHART_TOGGLE_FULLSCREEN = 'chart-toggle-fullscreen',
  CHART_EXIT_FULLSCREEN = 'chart-exit-fullscreen',
  CHART_ROOT = 'chart-root',

  CHART_SETTINGS_MORE_SETTING_BUTTON = 'chart-settings-more-setting-button',
  CHART_MORE_SETTING_MODAL = 'chart-more-setting-modal',
  MORE_SETTING_MODAL_BUTTON_CANDLESTICK_COLOR_SETTING = 'more-setting-modal-button-candlestick-color-setting',
  MORE_SETTING_MODAL_BUTTON_REMOVE_ALL_INDICATORS = 'more-setting-modal-button-remove-all-indicators',
  MORE_SETTING_MODAL_BUTTON_CLEAR_ALL_TRACK_DETAILS = 'more-setting-modal-button-clear-all-track-details',
  MORE_SETTING_MODAL_OPTION_TOGGLE_ASK_PRICE = 'more-setting-modal-option-toggle-ask-price',
  MORE_SETTING_MODAL_BUTTON_SWITCH_HIDE_ASK_PRICE = 'more-setting-modal-button-hide-ask-price',
  MORE_SETTING_MODAL_BUTTON_SWITCH_SHOW_ASK_PRICE = 'more-setting-modal-button-show-ask-price',
  MORE_SETTING_MODAL_OPTION_TOGGLE_PRICE_ALERTS = 'more-setting-modal-option-toggle-price-alerts',
  MORE_SETTING_MODAL_BUTTON_SWITCH_HIDE_PRICE_ALERTS = 'more-setting-modal-button-hide-price-alerts',
  MORE_SETTING_MODAL_BUTTON_SWITCH_SHOW_PRICE_ALERTS = 'more-setting-modal-button-show-price-alerts',
  MORE_SETTING_MODAL_BUTTON_CANCEL = 'more-setting-modal-button-cancel',
  MORE_SETTING_MODAL_BUTTON_SUBMIT = 'more-setting-modal-button-submit',

  CANDLESTICK_COLOR_SETTING_MODAL_BUTTON_BACK = 'candlestick-color-setting-modal-button-back',
  CANDLESTICK_COLOR_SETTING_MODAL_BUTTON_RESET = 'candlestick-color-setting-modal-button-reset',
  CANDLESTICK_COLOR_SETTING_MODAL_BUTTON_APPLY = 'candlestick-color-setting-modal-button-apply',

  COLOR_PICKER_MODAL_BACK_BUTTON = 'color-picker-modal-back-button',

  SYMBOL_SEARCH_SELECTOR = 'symbol-search-selector',
  SYMBOL_INPUT_SEARCH = 'symbol-input-search',
  SYMBOL_INPUT_SEARCH_CANCEL = 'symbol-input-search-cancel',
  SYMBOL_INPUT_SEARCH_CLEAR = 'symbol-input-search-clear',
  SYMBOL_DROPDOWN_RESULT = 'symbol-dropdown-result',
  SYMBOL_OVERVIEW_ID = 'symbol-overview-id',
  SYMBOL_OVERVIEW_NAME = 'symbol-overview-name',
  SYMBOL_INPUT_SEARCH_ITEMS = 'symbol-input-search-items',
  SYMBOL_INPUT_SEARCH_ITEMS_SYMBOL = 'symbol-input-search-items-symbol',
  SYMBOL_INPUT_SEARCH_ITEMS_DELETE = 'symbol-input-search-items-delete',
  SYMBOL_INPUT_SEARCH_HISTORY = 'symbol-input-search-history',
  SYMBOL_INPUT_SEARCH_HISTORY_DELETE = 'symbol-input-search-history-delete',
  SYMBOL_24HR_LOW = 'symbol-24hr-low',
  SYMBOL_24HR_HIGH = 'symbol-24hr-high',

  TRADE_ANALYSIS_BACK_BUTTON = 'trade-analysis-back-button',

  TRADE_FORM_PRICE_INFO_CHG_PERCENTAGE_TOOLTIP = 'trade-form-price-info-chg-percentage-tooltip',
  TRADE_FORM_PRICE_INFO_CURRENT_PRICE = 'trade-form-price-info-current-price',
  TRADE_FORM_PRICE_INFO_CHG_PERCENTAGE = 'trade-form-price-info-chg-percentage',
  TRADE_FORM_PRICE_INFO_24H_HIGH = 'trade-form-price-info-24h-high',
  TRADE_FORM_PRICE_INFO_24H_LOW = 'trade-form-price-info-24h-low',
  TRADE_FORM_PRICE_INFO_SPREAD = 'trade-form-price-info-spread',
  TRADE_FORM_MORE_SETTINGS = 'trade-form-more-settings',
  TRADE_FORM_ANALYSIS = 'trade-form-analysis',
  TRADE_FORM_CHART = 'trade-form-chart',
  TRADE_FORM_ONE_CLICK = 'trade-form-one-click',
  TRADE_FORM_TAB_ONE_CLICK = 'trade-form-tab-one-click',
  TRADE_FORM_TAB_TRADE = 'trade-form-tab-trade',

  TRADE_BUTTON_ORDER_BUY = 'trade-button-order-buy',
  TRADE_BUTTON_ORDER_SELL = 'trade-button-order-sell',
  TRADE_BUTTON_OCT_ORDER_BUY = 'trade-button-oct-order-buy',
  TRADE_BUTTON_OCT_ORDER_SELL = 'trade-button-oct-order-sell',
  TRADE_BOTTOM_SHEET = 'trade-bottom-sheet',
  TRADE_INPUT_VOLUME = 'trade-input-volume',
  TRADE_INPUT_MARKETRANGE_POINT = 'trade-input-marketrange-point',
  TRADE_INPUT_MARKETRANGE_INCREASE = 'trade-input-marketrange-increase',
  TRADE_INPUT_MARKETRANGE_DECREASE = 'trade-input-marketrange-decrease',
  TRADE_MARKETRANGE_FORMITEM = 'trade-marketrange-formitem',
  TRADE_MARKETRANGE_TOOLTIP = 'trade-marketrange-tooltip',
  TRADE_INPUT_PRICE = 'trade-input-price',
  TRADE_INPUT_STOP_LIMIT_PRICE = 'trade-input-stop-limit-price',
  TRADE_INPUT_TAKEPROFIT_POINTS = 'trade-input-takeprofit-points',
  TRADE_INPUT_STOPLOSS_POINTS = 'trade-input-stoploss-points',
  TRADE_INPUT_TAKEPROFIT_PRICE = 'trade-input-takeprofit-price',
  TRADE_INPUT_STOPLOSS_PRICE = 'trade-input-stoploss-price',
  TRADE_BUTTON_CANCEL = 'trade-button-cancel',
  TRADE_BUTTON_ORDER = 'trade-button-order',
  TRADE_SWAP_TO_UNITS = 'trade-swap-to-units',
  TRADE_SWAP_TO_VOLUME = 'trade-swap-to-volume',
  TRADE_DETAILS = 'trade-details',
  TRADE_DETAILS_HEADER = 'trade-details-header',
  TRADE_DETAILS_INFO_BUTTON = 'trade-details-info-button',
  TRADE_DETAILS_INFO_BOTTOM_SHEET = 'trade-details-info-bottom-sheet',
  TRADE_DETAILS_CONTENT = 'trade-details-content',
  TRADE_DETAILS_TRADE_SIZE = 'trade-details-trade-size',
  TRADE_DETAILS_MARGIN_REQUIRED = 'trade-details-margin-required',
  TRADE_DETAILS_AMOUNT_PER_TICK = 'trade-details-amount-per-tick',
  TRADE_DETAILS_POTENTIAL_GAIN = 'trade-details-potential-gain',
  TRADE_DETAILS_POTENTIAL_LOSS = 'trade-details-potential-loss',
  TRADE_DETAILS_RISK_REWARD = 'trade-details-risk-reward',
  TRADE_DETAILS_PIN_ICON = 'trade-details-pin-icon',
  TRADE_DROPDOWN_EXPIRY = 'trade-dropdown-expiry',
  TRADE_DROPDOWN_EXPIRY_GOOD_TILL_CANCELLED = 'trade-dropdown-expiry-good-till-cancelled',
  TRADE_DROPDOWN_EXPIRY_GOOD_TILL_DAY = 'trade-dropdown-expiry-good-till-day',
  TRADE_DROPDOWN_EXPIRY_SPECIFIED_DATE = 'trade-dropdown-expiry-specified_date',
  TRADE_DROPDOWN_EXPIRY_SPECIFIED_DATE_AND_TIME = 'trade-dropdown-expiry-specified-date-and-time',
  TRADE_DROPDOWN_FILL_POLICY = 'trade-dropdown-fill-policy',
  TRADE_DROPDOWN_DEVIATION = 'trade-dropdown-deviation',
  TRADE_DROPDOWN_ORDER_TYPE = 'trade-dropdown-order-type',
  TRADE_DROPDOWN_ORDER_TYPE_MARKET = 'trade-dropdown-order-type-market',
  TRADE_DROPDOWN_ORDER_TYPE_LIMIT = 'trade-dropdown-order-type-limit',
  TRADE_DROPDOWN_ORDER_TYPE_STOP = 'trade-dropdown-order-type-stop',
  TRADE_DROPDOWN_ORDER_TYPE_STOP_LIMIT = 'trade-dropdown-order-type-stop-limit',
  TRADE_VOLUME_INFO_LABEL = 'trade-volume-info-label',
  TRADE_VOLUME_INFO_VALUE = 'trade-volume-info-value',
  TRADE_VOLUME_INFO_MIN_VALUE = 'trade-volume-info-min-value',
  TRADE_LIVE_BUY_PRICE = 'trade-live-buy-price',
  TRADE_LIVE_SELL_PRICE = 'trade-live-sell-price',
  TRADE_BUTTON_PRE_TRADE_DETAILS = 'trade-button-pre-trade-details',
  TRADE_SHOW_ALL_SYMBOLS_CHECKED = 'trade-show-all-symbols-checked',
  TRADE_SHOW_ALL_SYMBOLS_UNCHECKED = 'trade-show-all-symbols-unchecked',

  TRADE_CONFIRMATION_MODAL = 'trade-confirmation-modal',
  TRADE_CONFIRMATION_BUTTON_CONFIRM = 'trade-confirmation-button-confirm',
  TRADE_CONFIRMATION_BUTTON_CLOSE = 'trade-confirmation-button-close',
  TRADE_CONFIRMATION_SYMBOL = 'trade-confirmation-symbol',
  TRADE_CONFIRMATION_SYMBOL_DESCRIPTION = 'trade-confirmation-symbol-description',
  TRADE_CONFIRMATION_ORDER_TYPE = 'trade-confirmation-order-type',
  TRADE_CONFIRMATION_ORDER_ID = 'trade-confirmation-order-id',
  TRADE_CONFIRMATION_LABEL = 'trade-confirmation-label',
  TRADE_CONFIRMATION_VALUE = 'trade-confirmation-value',

  TRADE_ONE_POINT_EQUAL_LABEL = 'trade-one-point-equal-label',
  EDIT_ONE_POINT_EQUAL_LABEL = 'edit-one-point-equal-label',

  EDIT_INPUT_EXPIRY_DATE = 'edit-input-expiry-date',
  TRADE_INPUT_EXPIRY_DATE = 'trade-input-expiry-date',
  EDIT_INPUT_EXPIRY_TIME = 'edit-input-expiry-time',
  TRADE_INPUT_EXPIRY_TIME = 'trade-input-expiry-time',
  EDIT_INPUT_EXPIRY_TIME_HOUR = 'edit-input-expiry-time-hour',
  TRADE_INPUT_EXPIRY_TIME_HOUR = 'trade-input-expiry-time-hour',
  EDIT_INPUT_EXPIRY_TIME_MINUTE = 'edit-input-expiry-time-minute',
  TRADE_INPUT_EXPIRY_TIME_MINUTE = 'trade-input-expiry-time-minute',
  EDIT_INPUT_EXPIRY_TIME_SECOND = 'edit-input-expiry-time-second',
  TRADE_INPUT_EXPIRY_TIME_SECOND = 'trade-input-expiry-time-second',

  TRADE_EXPIRY_FORMITEM = 'trade-expiry-formitem',
  TRADE_EXPIRY_DATE_FORMITEM = 'trade-expiry-date-formitem',
  TRADE_EXPIRY_TIME_FORMITEM = 'trade-expiry-time-formitem',
  TRADE_EXPIRY_DATE_INFO_BUTTON = 'trade-expiry-date-info-button',
  TRADE_EXPIRY_TIME_INFO_BUTTON = 'trade-expiry-time-info-button',
  TRADE_EXPIRY_TIMEZONE_INFO_BOTTOM_SHEET = 'trade-expiry-timezone-info-bottom-sheet',

  CALENDER_BUTTON_ORDER_HISTORY = 'calender-button-order-history',
  CALENDER_BUTTON_ASSET = 'calender-button-assets',
  CALENDER_BUTTON_ORDER_HISTORY_CONTENT = 'calender-button-order-history-content',
  CALENDER_BUTTON_ASSET_CONTENT = 'calender-button-assets-content',
  CALENDAR_INFO_BUTTON = 'calendar-info-button',
  CALENDAR_SETTINGS_BUTTON = 'calendar-settings-button',
  CALENDAR_EVENTS_DAY_ACCORDION = 'calendar-events-day-accordion',
  CALENDAR_EVENTS_EMPTY = 'calendar-events-empty',
  CALENDAR_FILTER_CATEGORIES = 'calendar-filter-categories',
  CALENDAR_FILTER_COUNTRIES = 'calendar-filter-countries',
  CALENDAR_FILTER_NOTIFICATION_STATUS = 'calendar-filter-notification-status',
  CALENDAR_FILTER_BUTTON_RESET = 'calendar-filter-button-reset',
  CALENDAR_FILTER_BUTTON_CONFIRM = 'calendar-filter-button-confirm',
  CALENDAR_FILTER_ROW_ICON = 'calendar-filter-row-icon',
  CALENDAR_FILTER_COUNTRIES_SEARCH = 'calendar-filter-countries-search',
  CALENDAR_FILTER_COUNTRIES_CANCEL = 'calendar-filter-countries-cancel',
  CALENDAR_FILTER_COUNTRIES_LIST = 'calendar-filter-countries-list',
  CALENDAR_FILTER_COUNTRIES_SELECT_ALL = 'calendar-filter-countries-select-all',
  CALENDAR_FILTER_COUNTRIES_BUTTON_CONFIRM = 'calendar-filter-countries-button-confirm',
  CALENDAR_FILTER_CATEGORIES_LIST = 'calendar-filter-categories-list',
  CALENDAR_FILTER_CATEGORIES_BUTTON_RESET = 'calendar-filter-categories-button-reset',
  CALENDAR_FILTER_CATEGORIES_BUTTON_CONFIRM = 'calendar-filter-categories-button-confirm',
  CALENDAR_FILTER_CATEGORIES_SEARCH = 'calendar-filter-categories-search',
  CALENDAR_FILTER_CATEGORIES_CANCEL = 'calendar-filter-categories-cancel',
  CALENDAR_FILTER_CATEGORIES_SELECT_ALL = 'calendar-filter-categories-select-all',
  CALENDAR_FILTER_NOTIFICATION_BUTTON_RESET = 'calendar-filter-notification-button-reset',
  CALENDAR_FILTER_NOTIFICATION_BUTTON_CONFIRM = 'calendar-filter-notification-button-confirm',
  CALENDAR_SETTINGS_NOTIFICATION_TIMING = 'calendar-settings-notification-timing',
  CALENDAR_SETTINGS_CATEGORIES = 'calendar-settings-categories',
  CALENDAR_SETTINGS_COUNTRIES = 'calendar-settings-countries',
  CALENDAR_SETTINGS_NOTIFICATION_TIMING_OPTION = 'calendar-settings-notification-timing-option',
  CALENDAR_SETTINGS_NOTIFICATION_TIMING_BUTTON_RESET = 'calendar-settings-notification-timing-button-reset',
  CALENDAR_SETTINGS_NOTIFICATION_TIMING_BUTTON_CONFIRM = 'calendar-settings-notification-timing-button-confirm',
  CALENDAR_SETTINGS_CATEGORIES_SEARCH = 'calendar-settings-categories-search',
  CALENDAR_SETTINGS_CATEGORIES_CANCEL = 'calendar-settings-categories-cancel',
  CALENDAR_SETTINGS_CATEGORIES_LIST = 'calendar-settings-categories-list',
  CALENDAR_SETTINGS_CATEGORIES_SELECT_ALL = 'calendar-settings-categories-select-all',
  CALENDAR_SETTINGS_CATEGORIES_BUTTON_RESET = 'calendar-settings-categories-button-reset',
  CALENDAR_SETTINGS_CATEGORIES_BUTTON_CONFIRM = 'calendar-settings-categories-button-confirm',
  CALENDAR_SETTINGS_COUNTRIES_SEARCH = 'calendar-settings-countries-search',
  CALENDAR_SETTINGS_COUNTRIES_CANCEL = 'calendar-settings-countries-cancel',
  CALENDAR_SETTINGS_COUNTRIES_LIST = 'calendar-settings-countries-list',
  CALENDAR_SETTINGS_COUNTRIES_SELECT_ALL = 'calendar-settings-countries-select-all',
  CALENDAR_SETTINGS_COUNTRIES_BUTTON_RESET = 'calendar-settings-countries-button-reset',
  CALENDAR_SETTINGS_COUNTRIES_BUTTON_CONFIRM = 'calendar-settings-countries-button-confirm',

  OCT_MODAL_BUTTON_CANCEL = 'oct-modal-button-cancel',
  OCT_MODAL_BUTTON_CONFIRM = 'oct-modal-button-confirm',
  OCT_ACTIVATE_BOTTOM_SHEET = 'oct-activate-bottom-sheet',
  OCT_DEACTIVATE_BOTTOM_SHEET = 'oct-deactivate-bottom-sheet',
  OCT_ACTIVATE_BUTTON = 'oct-activate-button',
  OCT_DEACTIVATE_BUTTON = 'oct-deactivate-button',
  OCT_CANCEL_BUTTON = 'oct-cancel-button',
  ALERT_ERROR = 'alert-error',
  ALERT_SUCCESS = 'alert-success',

  SPECIFICATION_SYMBOL = 'specification-symbol',
  SPECIFICATION_DESCRIPTION = 'specification-description',
  SPECIFICATION_REVENUE = 'specification-revenue',
  SPECIFICATION_TOTAL_ASSETS = 'specification-total-assets',
  SPECIFICATION_OPERATING_INCOME = 'specification-operating-income',
  SPECIFICATION_NET_INCOME = 'specification-net-income',
  SPECIFICATION_TOTAL_EQUITY = 'specification-total-equity',
  SPECIFICATION_MAX_LOT_SIZE = 'specification-max-lot-size',
  SPECIFICATION_MIN_LOT_SIZE = 'specification-min-lot-size',
  SPECIFICATION_LOT_SIZE_STEP = 'specification-lot-size-step',
  SPECIFICATION_POINT_STEP = 'specification-point-step',
  SPECIFICATION_MIN_STOP_DISTANCE = 'specification-min-stop-distance',
  SPECIFICATION_CONTRACT_SIZE = 'specification-contract-size',
  SPECIFICATION_MARGIN_CURRENCY = 'specification-margin-currency',
  SPECIFICATION_MARGIN_HEDGE = 'specification-margin-hedge',
  SPECIFICATION_INITIAL_MARGIN = 'specification-initial-margin',
  SPECIFICATION_MAINTENANCE_MARGIN = 'specification-maintenance-margin',
  SPECIFICATION_SWAP_TYPE = 'specification-swap-type',
  SPECIFICATION_SWAP_LONG = 'specification-swap-long',
  SPECIFICATION_SWAP_SHORT = 'specification-swap-short',
  SPECIFICATION_SWAP_ROLLOVER_3_DAYS = 'specification-swap-rollover-3-days',

  DROPDOWN_CHART_SETTING = 'dropdown-chart-setting',
  DROPDOWN_CHART_SETTING_CHART_COLOR_SETTING = 'dropdown-chart-setting-chart-color-setting',
  DROPDOWN_CHART_SETTING_REMOVE_ALL_DRAWING = 'dropdown-chart-setting-remove-all-drawing',
  DROPDOWN_CHART_SETTING_REMOVE_ALL_INDICATORS = 'dropdown-chart-setting-remove-all-indicators',
  DROPDOWN_CHART_SETTING_RESET_CHART = 'dropdown-chart-setting-reset-chart',
  DROPDOWN_CHART_SETTING_HIDE_ASK_PRICE_ON_Y_AXIS = 'dropdown-chart-setting-hide-ask-price-on-y-axis',
  DROPDOWN_CHART_SETTING_SHOW_ASK_PRICE_ON_Y_AXIS = 'dropdown-chart-setting-show-ask-price-on-y-axis',
  DROPDOWN_CHART_SETTING_CLEAR_ALL_TRACK_DETAILS = 'dropdown-chart-setting-clear-all-track-details',
  DROPDOWN_CHART_SETTING_REMOVE_ALL_INDICATORS_AND_DRAWINGS = 'dropdown-chart-setting-remove-all-indicators-and-drawings',
  DROPDOWN_CHART_SETTING_SHOW_ALL_PRICE_ALERTS = 'dropdown-chart-setting-show-all-price-alerts',
  DROPDOWN_CHART_SETTING_HIDE_ALL_PRICE_ALERTS = 'dropdown-chart-setting-hide-all-price-alerts',

  CONTEXT_MENU_CHART_SETTING_CHART_COLOR_SETTING = 'context-menu-chart-setting-chart-color-setting',
  CONTEXT_MENU_CHART_SETTING_REMOVE_ALL_DRAWING = 'context-menu-chart-setting-remove-all-drawing',
  CONTEXT_MENU_CHART_SETTING_REMOVE_ALL_INDICATORS = 'context-menu-chart-setting-remove-all-indicators',
  CONTEXT_MENU_CHART_SETTING_REMOVE_ALL_INDICATORS_AND_DRAWINGS = 'context-menu-chart-setting-remove-all-indicators-and-drawings',
  CONTEXT_MENU_CHART_SETTING_HIDE_ASK_PRICE_ON_Y_AXIS = 'context-menu-chart-setting-hide-ask-price-on-y-axis',
  CONTEXT_MENU_CHART_SETTING_SHOW_ASK_PRICE_ON_Y_AXIS = 'context-menu-chart-setting-show-ask-price-on-y-axis',
  CONTEXT_MENU_CHART_SETTING_CLEAR_ALL_TRACK_DETAILS = 'context-menu-chart-setting-clear-all-track-details',
  CONTEXT_MENU_CHART_SETTING_RESET_CHART = 'context-menu-chart-setting-reset-chart',
  CONTEXT_MENU_CHART_SETTING_SHOW_ALL_PRICE_ALERTS = 'context-menu-chart-setting-show-all-price-alerts',
  CONTEXT_MENU_CHART_SETTING_HIDE_ALL_PRICE_ALERTS = 'context-menu-chart-setting-hide-all-price-alerts',

  CHART_PERIOD_OPTION = 'chart-period-option',
  CHART_TIMEFRAME_DROPDOWN = 'chart-timeframe-dropdown',
  CHART_TIMEFRAME_MINUTES_DROPDOWN = 'chart-timeframe-minutes-dropdown',
  CHART_TIMEFRAME_HOURS_DROPDOWN = 'chart-timeframe-hours-dropdown',
  CHART_TIMEFRAME_DAYS_DROPDOWN = 'chart-timeframe-days-dropdown',

  CHART_INDICATOR = 'chart_indicator',
  CHART_INDICATOR_BUTTON_CLOSE = 'chart-indicator-button-close',
  CHART_INDICATOR_MA = 'chart-indicator-ma',
  CHART_INDICATOR_SD = 'chart-indicator-sd',
  CHART_INDICATOR_SO = 'chart-indicator-so',
  CHART_INDICATOR_ATR = 'chart-indicator-atr',
  CHART_INDICATOR_SAR = 'chart-indicator-sar',
  CHART_INDICATOR_CCI = 'chart-indicator-cci',
  CHART_INDICATOR_RSI = 'chart-indicator-rsi',
  CHART_INDICATOR_BOLL = 'chart-indicator-boll',
  CHART_INDICATOR_MACD = 'chart-indicator-macd',
  CHART_INDICATOR_EMA = 'chart-indicator-ema',
  CHART_INDICATOR_WMA = 'chart-indicator-wma',
  CHART_TRADE_BUTTON_CLOSE = 'chart-trade-button-close',
  CHART_INDICATOR_CUSTOMIZE = 'chart-indicator-customize',
  CHART_INDICATOR_DETAIL_INPUT_FIELD = 'chart-indicator-detail-input-field',
  CHART_INDICATOR_RESET_BUTTON = 'chart-indicator-reset-button',

  CHART_PROVIDER_SELECTOR = 'chart-provider-selector',
  CHART_PROVIDER_OPTION_ORIGINAL = 'chart-provider-option-original',
  CHART_PROVIDER_OPTION_TRADINGVIEW = 'chart-provider-option-tradingview',

  CHART_PERIOD_SELECTOR = 'chart-period-selector',
  CHART_PERIOD_BOTTOM_SHEET = 'chart-period-bottom-sheet',
  CHART_PERIOD_OPTION_1_MINUTE = 'chart-period-option-1-minute',
  CHART_PERIOD_OPTION_2_MINUTE = 'chart-period-option-2-minute',
  CHART_PERIOD_OPTION_3_MINUTE = 'chart-period-option-3-minute',
  CHART_PERIOD_OPTION_4_MINUTE = 'chart-period-option-4-minute',
  CHART_PERIOD_OPTION_5_MINUTE = 'chart-period-option-5-minute',
  CHART_PERIOD_OPTION_6_MINUTE = 'chart-period-option-6-minute',
  CHART_PERIOD_OPTION_10_MINUTE = 'chart-period-option-10-minute',
  CHART_PERIOD_OPTION_15_MINUTE = 'chart-period-option-15-minute',
  CHART_PERIOD_OPTION_20_MINUTE = 'chart-period-option-20-minute',
  CHART_PERIOD_OPTION_30_MINUTE = 'chart-period-option-30-minute',
  CHART_PERIOD_OPTION_1_HOUR = 'chart-period-option-1-hour',
  CHART_PERIOD_OPTION_2_HOUR = 'chart-period-option-2-hour',
  CHART_PERIOD_OPTION_3_HOUR = 'chart-period-option-3-hour',
  CHART_PERIOD_OPTION_4_HOUR = 'chart-period-option-4-hour',
  CHART_PERIOD_OPTION_6_HOUR = 'chart-period-option-6-hour',
  CHART_PERIOD_OPTION_8_HOUR = 'chart-period-option-8-hour',
  CHART_PERIOD_OPTION_12_HOUR = 'chart-period-option-12-hour',
  CHART_PERIOD_OPTION_1_DAY = 'chart-period-option-1-day',
  CHART_PERIOD_OPTION_1_WEEK = 'chart-period-option-1-week',
  CHART_PERIOD_OPTION_1_MONTH = 'chart-period-option-1-month',
  CHART_PERIOD_MORE_BUTTON = 'chart-period-more-button',

  CHART_SERIES_SELECTOR = 'chart-series-selector',
  CHART_SERIES_DROPDOWN = 'chart-series-dropdown',
  CHART_SERIES_OPTION_LINE = 'chart-series-option-line',
  CHART_SERIES_OPTION_LINE_ASK = 'chart-series-option-line-ask',
  CHART_SERIES_OPTION_CANDLESTICK = 'chart-series-option-candlestick',

  CHART_ORIENTATION_TOGGLE = 'chart-orientation-toggle',
  CHART_BACK_TO_LATEST_BUTTON = 'chart-back-to-latest-button',

  SIDE_BAR_OPTION_HOME = 'side-bar-option-home',
  SIDE_BAR_OPTION_TRADE = 'side-bar-option-trade',
  SIDE_BAR_OPTION_QUOTEBOARD = 'side-bar-option-quoteboard',
  SIDE_BAR_OPTION_MARKETS = 'side-bar-option-markets',
  SIDE_BAR_OPTION_ASSETS = 'side-bar-option-assets',
  SIDE_BAR_OPTION_SIGNAL = 'side-bar-option-signal',
  SIDE_BAR_OPTION_NEWS = 'side-bar-option-news',
  SIDE_BAR_OPTION_CALENDAR = 'side-bar-option-calendar',
  SIDE_BAR_OPTION_COPY_TRADE = 'side-bar-option-copy-trade',
  SIDE_BAR_OPTION_DEALER = 'side-bar-option-dealer',
  SIDE_BAR_OPTION_EDUCATION = 'side-bar-option-education',
  SIDE_BAR_OPTION_INFORMATION = 'side-bar-option-information',
  SIDE_BAR_OPTION_MENU = 'side-bar-option-menu',

  SPIN_LOADER = 'spin-loader',
  SWITCH_THEME_BUTTON = 'switch-theme-button',

  SETTING_BUTTON = 'setting-button',
  SETTING_OPTION_LINK_SWITCH_TO_LIVE = 'setting-option-switch-to-live',
  SETTING_OPTION_LINK_SWITCH_TO_DEMO = 'setting-option-switch-to-demo',
  SETTING_OPTION_SWITCH_TO_LIVE = 'setting-option-switch-to-live',
  SETTING_OPTION_SWITCH_TO_DEMO = 'setting-option-switch-to-demo',
  SETTING_OPTION_OPEN_DEMO_ACCOUNT = 'setting-option-open-demo-account',
  SETTING_OPTION_NOTIFICATION_SETTING = 'setting-option-notification-setting',
  SETTING_OPTION_LANGUAGE = 'setting-option-language',
  SETTING_OPTION_CHANGE_PASSWORD = 'setting-option-change-password',
  SETTING_OPTION_LINKED_DEVICE = 'setting-option-linked-device',
  SETTING_OPTION_CONTACT_INFORMATION = 'setting-option-contact-information',
  SETTING_OPTION_LOGOUT = 'setting-option-logout',
  SETTING_OPTION_OCT = 'setting-option-oct',
  SETTING_OPTION_APPEARANCE = 'setting-option-appearance',
  SETTING_OPTION_BIOMETRICS_SETTINGS = 'setting-option-biometrics-settings',
  SETTING_OPTION_REQUEST_CANCEL_ACCOUNT = 'setting-option-request-cancel-account',
  SETTING_OPTION_HELP_SUPPORT = 'setting-option-help-support',
  SETTING_OPTION_SUPPORT = 'setting-option-support',
  SUPPORT_TOPIC_INPUT = 'support-topic-input',
  SUPPORT_DESCRIPTION_INPUT = 'support-description-input',
  SUPPORT_SUBMIT_BUTTON = 'support-submit-button',
  SUPPORT_UPLOAD_IMAGE_BUTTON = 'support-upload-image-button',
  SUPPORT_REMOVE_IMAGE_BUTTON = 'support-remove-image-button',
  SETTING_OPTION_ABOUT = 'setting-option-about',
  SETTING_OPTION_PAYMENT_METHOD = 'setting-option-payment-method',
  SETTINGS_TAB_SECURITY = 'settings-tab-security',
  SETTINGS_TAB_PREFERENCES = 'settings-tab-preferences',
  SETTINGS_TAB_NOTIFICATIONS = 'settings-tab-notifications',
  SETTING_NOTIFICATION_TOGGLE = 'setting-notification-toggle',
  SETTING_OPTION_LINKED_DEVICES = 'setting-option-linked-devices',
  SETTING_OPTION_DELETE_ACCOUNT = 'setting-option-delete-account',

  CANDLESTICK_COLOR_SETTING_MODAL = 'candlestick-color-setting-modal',
  ADS_SKIP_BUTTON = 'ads-skip-button',

  NAVIGATION_BACK_BUTTON = 'navigation-back-button',
  ACTION_SHEET_CANCEL_BUTTON = 'action-sheet-cancel-button',

  FEATURE_ANNOUNCEMENT_MODAL = 'feature-announcement-modal',
  FEATURE_ANNOUNCEMENT_BOTTOM_SHEET = 'feature-announcement-bottom-sheet',
  FEATURE_ANNOUNCEMENT_MODAL_GOT_IT_BUTTON = 'feature-announcement-modal-got-it-button',
  FEATURE_ANNOUNCEMENT_MODAL_TRY_IT_NOW_BUTTON = 'feature-announcement-modal-try-it-now-button',
  FEATURE_ANNOUNCEMENT_MODAL_MEDIA_LEFT_BUTTON = 'feature-announcement-modal-media-left-button',
  FEATURE_ANNOUNCEMENT_MODAL_MEDIA_RIGHT_BUTTON = 'feature-announcement-modal-media-right-button',
  FEATURE_ANNOUNCEMENT_TAG = 'feature-announcement-tag',

  CONFIRMATION_MODAL = 'confirmation-modal',
  CONFIRMATION_MODAL_BUTTON_CANCEL = 'confirmation-modal-button-cancel',
  CONFIRMATION_MODAL_BUTTON_SUBMIT = 'confirmation-modal-button-submit',

  ANALYSIS_ACTION_TITLE = 'analysis-action-title',
  ANALYSIS_ACTION_VALUE = 'analysis-action-value',
  ANALYSIS_DESCRIPTION_TITLE = 'analysis-description-title',
  ANALYSIS_DESCRIPTION_VALUE = 'analysis-description-value',

  COPY_TO_ORDER_1 = 'copy-to-order-1',
  COPY_TO_ORDER_2 = 'copy-to-order-2',

  // Signal Screen
  SIGNAL_SCREEN = 'signal-screen',
  SIGNAL_TAB_CONTAINER = 'signal-tab-container',
  SIGNAL_TAB_FAVOURITE = 'signal-tab-favourite',
  SIGNAL_TAB_ALL = 'signal-tab-all',
  SIGNAL_FILTER_FAVOURITE = 'signal-filter-favourite',
  SIGNAL_FILTER_ALL = 'signal-filter-all',

  // Signal List
  SIGNAL_LIST = 'signal-list',
  SIGNAL_LIST_HEADER = 'signal-list-header',
  SIGNAL_LIST_HEADER_MARKETS = 'signal-list-header-markets',
  SIGNAL_LIST_HEADER_STATUS = 'signal-list-header-status',
  SIGNAL_LIST_HEADER_CONFIDENCE = 'signal-list-header-confidence',
  SIGNAL_LIST_HEADER_MODIFIED = 'signal-list-header-modified',
  SIGNAL_LIST_HEADER_PUBLISHED = 'signal-list-header-published',

  // Signal List Item
  SIGNAL_ROW = 'signal-row',
  SIGNAL_ROW_SYMBOL = 'signal-row-symbol',
  SIGNAL_ROW_SYMBOL_NAME = 'signal-row-symbol-name',
  SIGNAL_ROW_SYMBOL_DESCRIPTION = 'signal-row-symbol-description',
  SIGNAL_ROW_SYMBOL_TAG = 'signal-row-symbol-tag',
  SIGNAL_ROW_ORDER_STATUS = 'signal-row-order-status',
  SIGNAL_ROW_CONFIDENCE = 'signal-row-confidence',
  SIGNAL_ROW_MODIFIED_DATE = 'signal-row-modified-date',
  SIGNAL_ROW_PUBLISHED_DATE = 'signal-row-published-date',
  SIGNAL_ROW_STAR = 'signal-row-star',
  SIGNAL_ROW_MARKET_STATUS = 'signal-row-market-status',
  SIGNALS_SYMBOL = 'signals-symbol',

  // Signal Locked Banner
  SIGNAL_LOCKED_BANNER = 'signal-locked-banner',
  SIGNAL_INTEREST_MODAL = 'signal-interest-modal',
  SIGNAL_EXPRESS_INTEREST_BUTTON = 'signal-express-interest-button',

  // Signal Sticky Column
  SIGNAL_STICKY_COLUMN = 'signal-sticky-column',
  SIGNAL_STICKY_COLUMN_ITEM = 'signal-sticky-column-item',

  // Signal Analysis Screen
  SIGNAL_ANALYSIS_SCREEN = 'signal-analysis-screen',
  SIGNAL_ANALYSIS_HEADER = 'signal-analysis-header',
  SIGNAL_ANALYSIS_HEADER_BACK_BUTTON = 'signal-analysis-header-back-button',
  SIGNAL_ANALYSIS_HEADER_TITLE = 'signal-analysis-header-title',
  SIGNAL_ANALYSIS_SYMBOL_INFO = 'signal-analysis-symbol-info',
  SIGNAL_ANALYSIS_CHART_TOGGLE = 'signal-analysis-chart-toggle',
  SIGNAL_ANALYSIS_CHART = 'signal-analysis-chart',
  SIGNAL_ANALYSIS_PRICE_INFO = 'signal-analysis-price-info',
  SIGNAL_ANALYSIS_STATS = 'signal-analysis-stats',
  SIGNAL_ANALYSIS_PHRASES = 'signal-analysis-phrases',
  SIGNAL_ANALYSIS_RESISTANCE_GRID = 'signal-analysis-resistance-grid',
  SIGNAL_ANALYSIS_LAST_MODIFIED = 'signal-analysis-last-modified',

  // Signal Analysis Trade Plan
  SIGNAL_ANALYSIS_TRADE_PLAN = 'signal-analysis-trade-plan',
  SIGNAL_ANALYSIS_TRADE_PLAN_HEADER = 'signal-analysis-trade-plan-header',
  SIGNAL_ANALYSIS_TRADE_PLAN_TOOLTIP = 'signal-analysis-trade-plan-tooltip',
  SIGNAL_ANALYSIS_TRADE_PLAN_INFO_BUTTON = 'signal-analysis-trade-plan-info-button',
  SIGNAL_ANALYSIS_TRADE_PLAN_INFO_BOTTOM_SHEET = 'signal-analysis-trade-plan-info-bottom-sheet',
  SIGNAL_ANALYSIS_TRADE_PLAN_INFO_BOTTOM_SHEET_CONFIRM = 'signal-analysis-trade-plan-info-bottom-sheet-confirm',
  SIGNAL_ANALYSIS_TRADE_PLAN_ENTRY_PRICE = 'signal-analysis-trade-plan-entry-price',
  SIGNAL_ANALYSIS_TRADE_PLAN_STOP_LOSS = 'signal-analysis-trade-plan-stop-loss',
  SIGNAL_ANALYSIS_TRADE_PLAN_TAKE_PROFIT_1 = 'signal-analysis-trade-plan-take-profit-1',
  SIGNAL_ANALYSIS_TRADE_PLAN_TAKE_PROFIT_2 = 'signal-analysis-trade-plan-take-profit-2',

  PORTFOLIO_ROW_STAR = 'portfolio-row-star',
  PORTFOLIO_ROW_SYMBOL = 'portfolio-row-symbol',
  PORTFOLIO_ROW_ORDER_TYPE = 'portfolio-row-order-type',

  TOP_PICKS_STAR = 'top-picks-star',
  TOP_PICKS_SYMBOL = 'top-picks-symbol',
  TOP_GAINER_STAR = 'top-gainer-star',
  TOP_GAINERS_SYMBOL = 'top-gainers-symbol',
  TOP_LOSER_STAR = 'top-loser-star',
  TOP_LOSERS_SYMBOL = 'top-losers-symbol',

  MARKET_SECTION_TITLE = 'market-section-title',
  MARKET_SECTION_TITLE_MORE = 'market-section-title-more',
  MARKET_SECTION_TITLE_MORE_DROPDOWN = 'market-section-title-more-dropdown',
  MARKET_SECTION_TITLE_MORE_DROPDOWN_ITEM = 'market-section-title-more-dropdown-item',
  MARKET_SECTION_SHOW_MORE = 'market-section-show-more',
  MARKET_SECTION_LIST = 'market-section-list',
  MARKET_FAVORITES_EMPTY = 'market-favorites-empty',
  MARKET_FAVORITE_SYMBOL_DRAG_HANDLE = 'market-favorite-symbol-drag-handle',
  WATCHLIST_STAR = 'watchlist-star',
  WATCHLIST_SYMBOL = 'watchlist-symbol',
  WATCHLIST_FILTER = 'watchlist-filter',
  WATCHLIST_FILTER_FAVOURITE = 'watchlist-filter-favourite',
  WATCHLIST_FILTER_ALL = 'watchlist-filter-all',
  WATCHLIST_LIST = 'watchlist-list',
  WATCHLIST_LIST_ITEM = 'watchlist-list-item',
  WATCHLIST_TABS = 'watchlist-tabs',
  MANAGE_FAVORITES_BOTTOM_SHEET = 'manage-favorites-bottom-sheet',
  MANAGE_FAVORITES_EDIT_BUTTON = 'manage-favorites-edit-button',
  MANAGE_FAVORITES_ADD_BUTTON = 'manage-favorites-add-button',
  MANAGE_FAVORITES_SORTABLE = 'manage-favorites-sortable',
  MARKET_NEWS_ROW = 'market-news-row',
  MARKET_NEWS_CONTENT_TEXT = 'market-news-content-text',
  MARKET_FAVORITE_SYMBOL = 'favorites-symbol',
  MARKET_MY_POSITIONS_SYMBOL = 'my-positions-symbol',
  MARKET_MY_POSITIONS_TYPE = 'my-positions-type',
  MARKET_MY_POSITIONS_ENTRY_PRICE = 'my-positions-entry-price',
  MARKET_MY_POSITIONS_TAKE_PROFIT = 'my-positions-take-profit',
  MARKET_MY_POSITIONS_PROFIT = 'my-positions-profit',
  MARKET_MY_POSITIONS_PRICE = 'my-positions-price',
  MARKET_MY_POSITIONS_STOP_LOSS = 'my-positions-stop-loss',
  MARKET_LIST_HEADER_NAVIGATION = 'market-list-header-navigation',

  EMPTY_MESSAGE = 'empty-message',
  EMPTY_COUNTRY = 'empty-country',
  SYMBOL_PREFERENCE = 'symbol-preference',
  SYMBOL_PREFERENCE_LABEL = 'symbol-preference-label',
  SYMBOL_PREFERENCE_CLOSE = 'symbol-preference-close',
  SYMBOL_PREFERENCE_SEARCH = 'symbol-preference-search',
  SYMBOL_PREFERENCE_OPTIONS = 'symbol-preference-options',
  SYMBOL_PREFERENCE_OPTION = 'symbol-preference-option',
  SYMBOL_PREFERENCE_SELECT_ALL = 'symbol-preference-select-all',
  SYMBOL_PREFERENCE_TABS = 'symbol-preference-tabs',
  SYMBOL_PREFERENCE_SAVE = 'symbol-preference-save',
  SYMBOL_PREFERENCE_CANCEL = 'symbol-preference-cancel',

  FORGOT_PASSWORD_EMAIL_INPUT = 'forgot-password-email-input',
  FORGOT_PASSWORD_ACCOUNT_ID_INPUT = 'forgot-password-account-id-input',
  FORGOT_PASSWORD_NEXT_BUTTON = 'forgot-password-next-button',
  FORGOT_PASSWORD_BACK_TO_LOG_IN = 'forgot-password-back-to-log-in',
  FORGOT_PASSWORD_CONTACT_US = 'forgot-password-contact-us',

  RESET_PASSWORD_EMAIL = 'reset-password-email',
  RESET_PASSWORD_SUBMIT = 'reset-password-submit',
  RESET_PASSWORD_BACK_TO_LOG_IN = 'reset-password-back-to-log-in',

  DEMO_SIGN_UP_NAME_INPUT = 'demo-sign-up-name-input',
  DEMO_SIGN_UP_FIRST_NAME_INPUT = 'demo-sign-up-first-name-input',
  DEMO_SIGN_UP_LAST_NAME_INPUT = 'demo-sign-up-last-name-input',
  DEMO_SIGN_UP_EMAIL_INPUT = 'demo-sign-up-email-input',
  DEMO_SIGN_UP_COUNTRY_SELECTOR = 'demo-sign-up-country-selector',
  DEMO_SIGN_UP_NUMBER_SELECTOR = 'demo-sign-up-number-selector',
  DEMO_SIGN_UP_NUMBER_INPUT = 'demo-sign-up-number-input',
  DEMO_SIGN_UP_DEPOSIT_SELECTOR = 'demo-sign-up-deposit-selector',
  DEMO_SIGN_UP_AGREE_AND_CONTINUE = 'demo-sign-up-agree-and-continue',
  DEMO_SIGN_UP_BACK_LOG_IN = 'demo-sign-up-back-log-in',
  DEMO_SIGN_UP_COPY_BUTTON = 'demo-sign-up-copy-button',

  SIGN_UP_EMAIL_INPUT = 'sign-up-email-input',
  SIGN_UP_PASSWORD_INPUT = 'sign-up-password-input',
  SIGN_UP_ACCOUNT_TYPE = 'sign-up-account-type',
  SIGN_UP_ACCOUNT_TYPE_DROPDOWN_LIST = 'sign-up-account-type-dropdown-list',
  SIGN_UP_ACCOUNT_TYPE_ITEM = 'sign-up-account-type-item',
  SIGN_UP_COUNTRY_DROPDOWN = 'sign-up-countr-dropdown',
  SIGN_UP_COUNTRY_SELECTOR = 'sign-up-country-selector',
  SIGN_UP_DEPOSIT_AMOUNT = 'sign-up-deposit-amount',
  SIGN_UP_DEPOSIT_AMOUNT_OPTION = 'sign-up-deposit-amount-option',
  SIGN_UP_COUNTRY_LIST = 'sign-up-country-list',
  SIGN_UP_COUNTRY_MODAL_CANCEL_BUTTON = 'sign-up-country-modal-cancel-button',
  SIGN_UP_COUNTRY_SEARCH_INPUT = 'sign-up-country-search-input',
  SIGN_UP_COUNTRY_OPTION = 'sign-up-country-option',
  SIGN_UP_ACKNOWLEDGE_CHECKED = 'sign-up-acknowledge-checked',
  SIGN_UP_ACKNOWLEDGE_UNCHECKED = 'sign-up-acknowledge-unchecked',
  TNC = 'tnc',
  PRIVACY_POLICY = 'privacy-policy',
  RISK_DISCLOSURE = 'risk-disclosure',
  SIGN_UP_BASIC_CONTINUE = 'sign-up-basic-continue',
  SIGN_UP_RESEND_VERIFICATION = 'sign-up-resend-verification',
  SIGN_UP_VERIFICATION_PIN = 'sign-up-verification-pin',
  SIGN_UP_VERIFICATION_BUTTON = 'sign-up-verification-button',
  SIGN_UP_COMPLETE_BUTTON = 'sign-up-complete-button',
  SIGN_UP_BACK_LOG_IN = 'sign-up-back-log-in',
  SIGN_UP_COMPLETE_CANCEL = 'sign-up-complete-cancel',

  NEWS_OPTION = 'news-option',
  NEWS_ACCORDION = 'news-accordion',
  ACCOUNT_SELECTOR = 'account-selector',
  ACCOUNT_INFO = 'account-info',
  ACCOUNT_INFO_STOP_OUT_LEVEL = 'account-info-stop-out-level',
  ACCOUNT_INFO_MARGIN_CALL_LEVEL = 'account-info-margin-call-level',
  ACCOUNT_INFO_DROPDOWN = 'account-info-dropdown',
  ACCOUNT_INFO_DROPDOWN_ICON = 'account-info-dropdown-icon',
  ACCOUNT_NAME = 'account-name',
  ACCOUNT_ID = 'account-id',
  ACCOUNT_DETAIL = 'account-detail',
  ACCOUNT_TYPE_TAG = 'account-type-tag',
  ACCOUNT_TOTAL_BALANCE = 'account-total-balance',
  ACCOUNT_OPTION_ITEM = 'account-option-item',
  ACCOUNT_OPTION_NAME = 'account-option-name',
  ACCOUNT_OPTION_DETAIL = 'account-option-detail',
  ACCOUNT_OPTION_BALANCE = 'account-option-balance',
  ADD_ACCOUNT = 'add-account',
  LINK_ACCOUNT_MODAL = 'link-account-modal',
  LINK_ACCOUNT_BOTTOM_SHEET = 'link-account-bottom-sheet',
  LINK_ACCOUNT_INFO_BUTTON = 'link-account-info-button',
  LINK_ACCOUNT_MODAL_CLOSE = 'link-account-modal-close',
  LINK_ACCOUNT_MODAL_CONFIRM = 'link-account-modal-confirm',
  LINK_ACCOUNT_MODAL_TITLE = 'link-account-modal-title',
  LINK_ACCOUNT_MODAL_ACCOUNT_ID = 'link-account-modal-account-id',
  LINK_ACCOUNT_MODAL_PASSWORD = 'link-account-modal-password',
  LINK_ACCOUNT_BOTTOM_SHEET_CONFIRM = 'link-account-bottom_sheet-confirm',
  LINK_ACCOUNT_FORM = 'link-account-form',
  LINK_ACCOUNT_FORM_ACCOUNT_ID = 'link-account-form-account-id',
  LINK_ACCOUNT_FORM_PASSWORD = 'link-account-form-password',
  LINK_ACCOUNT_FORM_CONFIRM = 'link-account-form-confirm',
  LINK_SWITCH_CONFIRMATION_MODAL = 'link-switch-confirmation-modal',
  LINK_SWITCH_CONFIRMATION_MODAL_CLOSE = 'link-switch-confirmation-modal-close',
  LINK_SWITCH_CONFIRMATION_MODAL_CONFIRM = 'link-switch-confirmation-modal-confirm',
  LINK_SWITCH_CONFIRMATION_MODAL_TITLE = 'link-switch-confirmation-modal-title',
  LINK_SWITCH_CONFIRMATION_MODAL_DESCRIPTION = 'link-switch-confirmation-modal-description',
  LINK_ACCOUNT_EMPTY = 'link-account-empty',
  RE_ENTER_PASSWORD_FORM = 're-enter-password-form',
  RE_ENTER_PASSWORD_FORM_ACCOUNT_ID = 're-enter-password-form-account-id',
  RE_ENTER_PASSWORD_FORM_PASSWORD = 're-enter-password-form-password',
  RE_ENTER_PASSWORD_FORM_CONFIRM = 're-enter-password-form-confirm',
  LINKED_DEVICES_CANCEL = 'linked-devices-cancel',
  LINKED_DEVICES_EDIT = 'linked-devices-edit',

  CHANGE_PASSWORD_MODAL = 'change-password-modal',
  CHANGE_PASSWORD_MODAL_CLOSE = 'change-password-modal-close',
  CHANGE_PASSWORD_MODAL_CONFIRM = 'change-password-modal-confirm',
  CHANGE_PASSWORD_MODAL_TITLE = 'change-password-modal-title',
  CHANGE_PASSWORD_MODAL_OLD_PASSWORD = 'change-password-modal-old-password',
  CHANGE_PASSWORD_MODAL_NEW_PASSWORD = 'change-password-modal-new-password',
  CHANGE_PASSWORD_MODAL_CONFIRM_NEW_PASSWORD = 'change-password-modal-confirm-new-password',
  DEMO_ACCOUNT_CREATION_MODAL = 'demo-account-creation-modal',
  DEMO_ACCOUNT_CREATION_MODAL_CLOSE = 'demo-account-creation-modal-close',
  DEMO_ACCOUNT_CREATION_MODAL_CONFIRM = 'demo-account-creation-modal-confirm',
  DEMO_ACCOUNT_CREATION_MODAL_TITLE = 'demo-account-creation-modal-title',
  DEMO_ACCOUNT_CREATION_MODAL_NAME = 'demo-account-creation-modal-name',
  DEMO_ACCOUNT_CREATION_MODAL_FIRST_NAME = 'demo-account-creation-modal-first-name',
  DEMO_ACCOUNT_CREATION_MODAL_LAST_NAME = 'demo-account-creation-modal-last-name',
  DEMO_ACCOUNT_CREATION_MODAL_EMAIL = 'demo-account-creation-modal-email',
  DEMO_ACCOUNT_CREATION_MODAL_COUNTRY = 'demo-account-creation-modal-country',
  DEMO_ACCOUNT_CREATION_MODAL_PHONE = 'demo-account-creation-modal-phone',
  DEMO_ACCOUNT_CREATION_MODAL_DEPOSIT = 'demo-account-creation-modal-deposit',
  DEMO_ACCOUNT_CREATION_MODAL_AGREEMENT = 'demo-account-creation-modal-agreement',
  INPUT_FIELD_VALIDATION = 'input-field-validation',
  COUNTRY_DIAL_CODE_DROPDOWN = 'country-dial-code-dropdown',
  COUNTRY_DIAL_CODE_ITEM = 'country-dial-code-item',
  COUNTRY_DIAL_CODE_LIST = 'country-dial-code-list',
  COUNTRY_DIAL_CODE = 'country-dial-code',
  COUNTRY_DIAL_CODE_SEARCH = 'country-dial-code-search',
  DEPOSIT_DROPDOWN_ITEM = 'deposit-dropdown-item',
  DEPOSIT_DROPDOWN_LIST = 'deposit-dropdown-list',
  DEMO_ACCOUNT_COMPLETION_MODAL = 'demo-account-completion-modal',
  DEMO_ACCOUNT_COMPLETION_MODAL_TITLE = 'demo-account-completion-modal-title',
  DEMO_ACCOUNT_COMPLETION_MODAL_SIGN_IN = 'demo-account-completion-modal-sign-in',
  DEMO_COMPLETION_LABEL = 'demo-completion-label',
  DEMO_COMPLETION_VALUE = 'demo-completion-value',
  PAGINATION_NEXT = 'pagination-next',
  PAGINATION_PREV = 'pagination-prev',
  RESET_PASSWORD_LINK = 'reset-password-link',
  COLUMN_PREFERENCE = 'column-preference',
  ORDER_SORT_SELECTOR = 'order-sort-selector',
  ORDER_SORT_OPTIONS = 'order-sort-options',
  SORT_OPTION_ITEM = 'sort-option-item',
  ORDER_COLUMN_PREFERENCE_MODAL = 'order-column-preference-modal',
  ORDER_COLUMN_PREFERENCE_MODAL_CLOSE = 'order-column-preference-modal-close',
  ORDER_COLUMN_PREFERENCE_MODAL_TITLE = 'order-column-preference-modal-title',
  ORDER_COLUMN_PREFERENCE_MODAL_SAVE = 'order-column-preference-modal-save',
  ORDER_COLUMN_PREFERENCE_MODAL_CANCEL = 'order-column-preference-modal-cancel',
  ORDER_COLUMN_PREFERENCE_MODAL_SELECT_ALL = 'order-column-preference-modal-select-all',
  ORDER_COLUMN_PREFERENCE_MODAL_ITEM = 'order-column-preference-modal-item',

  QUOTEBOARD_CARD = 'quoteboard-card',
  QUOTEBOARD_CARD_INPUT_QUANTITY = 'quoteboard-card-input-quantity',
  QUOTEBOARD_CARD_BUTTON_BUY = 'quoteboard-card-button-buy',
  QUOTEBOARD_CARD_BUTTON_BUY_VOLUME = 'quoteboard-card-button-buy-volume',
  QUOTEBOARD_CARD_BUTTON_SELL = 'quoteboard-card-button-sell',
  QUOTEBOARD_CARD_BUTTON_SELL_VOLUME = 'quoteboard-card-button-sell-volume',
  QUOTEBOARD_CARD_DROPDOWN = 'quoteboard-card-dropdown',
  QUOTEBOARD_CARD_SYMBOL = 'quoteboard-card-symbol',
  QUOTEBOARD_CARD_SPREAD = 'quoteboard-card-spread',
  QUOTEBOARD_CARD_SPREAD_VALUE = 'quoteboard-card-spread-value',
  QUOTEBOARD_CARD_LASTPRICE = 'quoteboard-card-lastprice',
  QUOTEBOARD_CARD_PROFIT = 'quoteboard-card-profit',
  QUOTEBOARD_TABLE = 'quoteboard-table',
  QUOTEBOARD_QUANTITY_ASK = 'quoteboard-quantity-ask',
  QUOTEBOARD_ASK = 'quoteboard-ask',
  QUOTEBOARD_BID = 'quoteboard-bid',
  QUOTEBOARD_QUANTITY_BID = 'quoteboard-quantity-bid',
  QUOTEBOARD_EXPAND_CARD_ITEM = 'quoteboard-expand-card-item',
  QUOTEBOARD_ASK_INDICATOR_LINE = 'quoteboard-ask-indicator-line',
  QUOTEBOARD_BID_INDICATOR_LINE = 'quoteboard-bid-indicator-line',
  // Quoteboard setting
  QUOTEBOARD_SETTING_BUTTON = 'quoteboard-setting-button',
  QUOTEBOARD_SETTING_CANCEL_BUTTON = 'quoteboard-setting-cancel-button',
  QUOTEBOARD_SETTING_CANCEL_MODAL = 'quoteboard-setting-cancel-modal',
  QUOTEBOARD_SETTING_ITEM = 'quoteboard-setting-item',
  QUOTEBOARD_SETTING_ITEM_CHECKBOX = 'quoteboard-setting-item-checkbox',
  QUOTEBOARD_SETTING_ITEM_DRAG_HANDLE = 'quoteboard-setting-item-drag-handle',
  QUOTEBOARD_SETTING_ITEM_TEXT = 'quoteboard-setting-item-text',
  QUOTEBOARD_SETTING_RESET_BUTTON = 'quoteboard-setting-reset-button',
  QUOTEBOARD_SETTING_SAVE_BUTTON = 'quoteboard-setting-save-button',
  QUOTEBOARD_SETTING_SELECT_ALL_CHECKBOX = 'quoteboard-setting-select-all-checkbox',
  QUOTEBOARD_TRADE_VOLUME_SETTING_BUTTON = 'quoteboard-trade-volume-setting-button',
  QUOTEBOARD_TRADE_VOLUME_SETTING_CANCEL_BUTTON = 'quoteboard-trade-volume-setting-cancel-button',
  QUOTEBOARD_TRADE_VOLUME_SETTING_SAVE_BUTTON = 'quoteboard-trade-volume-setting-save-button',

  MANAGE_ACCOUNT_DELETE = 'manage-account-delete',
  MANAGE_ACCOUNT_CANCEL = 'manage-account-cancel',
  MANAGE_ACCOUNT_EDIT = 'manage-account-edit',
  MANAGE_ACCOUNT_LINK_ACCOUNT = 'manage-account-link-account',
  EMAIL_INFORMATION = 'email-information',
  PHONE_INFORMATION = 'phone-information',
  WEBSITE_ICON = 'web-site-icon',
  BROWSE_SYMBOLS = 'browse-symbols',
  LEARN_EMPTY = 'learn-empty',
  NEWS_EMPTY = 'news-empty',
  NEWS_DETAIL_EMPTY = 'news-detail-empty',

  MENU_SEARCH_INPUT = 'menu-search-input',
  MENU_SEARCH_CANCEL = 'menu-search-cancel',
  MENU_SEARCH_CLEAR = 'menu-search-clear',
  MENU_SEARCH_RESULT = 'menu-search-result',
  MENU_SEARCH_RESULT_ITEM = 'menu-search-result-item',
  MENU_SEARCH_EMPTY = 'menu-search-empty',

  COLOR_PICKER_BOTTOM_SHEET = 'color-picker-bottom-sheet',
  COLOR_PICKER_HEX_INPUT = 'color-picker-hex-input',
  COLOR_PICKER_RESET_BUTTON = 'color-picker-reset-button',
  COLOR_PICKER_ADD_BUTTON = 'color-picker-add-button',
  COLOR_PICKER_BACK_BUTTON = 'color-picker-back-button',
  COLOR_PICKER_ADD_CUSTOM_BUTTON = 'color-picker-add-custom-button',
  COLOR_PICKER_PALLET_RESET_BUTTON = 'color-picker-pallet-reset-button',
  COLOR_PICKER_PALLET_APPLY_BUTTON = 'color-picker-pallet-apply-button',

  DEMO_SIGN_UP_DIAL_CODE_SELECTOR = 'sign-up-phone-number-selector',
  DEMO_SIGN_UP_DIAL_CODE_SEARCH_INPUT = 'sign-up-phone-number-search-input',
  DEMO_SIGN_UP_DIAL_CODE_MODAL_CANCEL_BUTTON = 'sign-up-phone-number-modal-cancel-button',

  MARKET_RANGE_BOTTOM_SHEET = 'market-range-bottom-sheet',
  MARKET_RANGE_BOTTOM_SHEET_CONFIRM = 'market-range-bottom-sheet-confirm',
  MARKET_RANGE_INFO_BUTTON = 'market-range-info-button',

  CHANGE_PERCENT_BOTTOM_SHEET = 'change-percent-bottom-sheet',
  CHANGE_PERCENT_BOTTOM_SHEET_CONFIRM = 'change-percent-bottom-sheet-confirm',
  CHANGE_PERCENT_INFO_BUTTON = 'change-percent-info-button',

  NOTIFICATION_PERMISSION_ITEM = 'notification-permission-item',

  // Price Alert Management page
  PRICE_ALERT_MANAGEMENT_HEADER_INFO_BUTTON = 'price-alert-management-header-info-button',
  PRICE_ALERT_MANAGEMENT_HEADER_INFO_BOTTOM_SHEET = 'price-alert-management-header-info-bottom-sheet',
  PRICE_ALERT_MANAGEMENT_HIDE_BULK_EDIT_BUTTON = 'price-alert-management-hide-bulk-edit-button',
  PRICE_ALERT_MANAGEMENT_SHOW_BULK_EDIT_BUTTON = 'price-alert-management-show-bulk-edit-button',

  PRICE_ALERT_MANAGEMENT_CURRENT_SYMBOL_TAB = 'price-alert-management-current-symbol-tab',
  PRICE_ALERT_MANAGEMENT_ALL_SYMBOLS_TAB = 'price-alert-management-all-symbols-tab',

  // Price Alert Management screen footer actions
  PRICE_ALERT_MANAGEMENT_FOOTER = 'price-alert-management-footer',
  PRICE_ALERT_MANAGEMENT_FOOTER_SELECT_ALL = 'price-alert-management-footer-select-all',
  PRICE_ALERT_MANAGEMENT_FOOTER_DELETE_SELECTED = 'price-alert-management-footer-delete-selected',
  PRICE_ALERT_MANAGEMENT_FOOTER_CREATE_ALERT = 'price-alert-management-footer-create-alert',

  // Price Alert Symbol Header
  PRICE_ALERT_MANAGEMENT_SYMBOL_HEADER = 'price-alert-management-symbol-header',
  PRICE_ALERT_MANAGEMENT_SYMBOL_HEADER_CHECKBOX = 'price-alert-management-symbol-header-checkbox',
  PRICE_ALERT_MANAGEMENT_SYMBOL_DISABLED_ICON = 'price-alert-management-symbol-disabled-icon',

  // Price Alert Management accordion
  PRICE_ALERT_MANAGEMENT_ACCORDION = 'price-alert-management-accordion',
  PRICE_ALERT_MANAGEMENT_ALERT_ITEM = 'price-alert-management-alert-item',
  PRICE_ALERT_MANAGEMENT_ALERT_ITEM_CHECKBOX = 'price-alert-management-alert-item-checkbox',
  PRICE_ALERT_MANAGEMENT_ALERT_ITEM_TOGGLE = 'price-alert-management-alert-item-toggle',

  // Price Alert Management form
  PRICE_ALERT_MANAGEMENT_CREATE_ALERT_SUBMIT_BUTTON = 'price-alert-management-create-alert-submit-button',
  PRICE_ALERT_MANAGEMENT_UPDATE_ALERT_SUBMIT_BUTTON = 'price-alert-management-update-alert-submit-button',
  PRICE_ALERT_MANAGEMENT_DELETE_ALERT_SUBMIT_BUTTON = 'price-alert-management-delete-alert-submit-button',

  PRICE_ALERT_MANAGEMENT_CREATE_FORM = 'price-alert-management-create-form',
  PRICE_ALERT_MANAGEMENT_UPDATE_FORM = 'price-alert-management-update-form',

  PRICE_ALERT_MANAGEMENT_SYMBOL_DISABLED_ALERT = 'price-alert-management-symbol-disabled-alert',

  PRICE_ALERT_MANAGEMENT_CONDITION_FORM_ITEM = 'price-alert-management-condition-form-item',
  PRICE_ALERT_MANAGEMENT_CONDITION_SELECT_PICKER = 'price-alert-management-condition-select-picker',
  PRICE_ALERT_MANAGEMENT_CONDITION_OPT = 'price-alert-management-condition-opt',

  PRICE_ALERT_MANAGEMENT_TARGET_VALUE_INFO_BUTTON = 'price-alert-management-target-value-info-button',
  PRICE_ALERT_MANAGEMENT_TARGET_VALUE_BOTTOM_SHEET = 'price-alert-management-target-value-bottom-sheet',
  PRICE_ALERT_MANAGEMENT_TARGET_VALUE_FORM_ITEM = 'price-alert-management-target-value-form-item',
  PRICE_ALERT_MANAGEMENT_TARGET_VALUE_INPUT = 'price-alert-management-target-value-input',

  PRICE_ALERT_MANAGEMENT_FREQUENCY_FORM_ITEM = 'price-alert-management-frequency-form-item',
  PRICE_ALERT_MANAGEMENT_FREQUENCY_SELECT_PICKER = 'price-alert-management-frequency-select-picker',
  PRICE_ALERT_MANAGEMENT_FREQUENCY_OPT = 'price-alert-management-frequency-opt',

  // Price Alert Management Delete dialog
  PRICE_ALERT_MANAGEMENT_DELETE_MODAL = 'price-alert-management-delete-modal',

  // Price Alert Management Error/Warning Msg modals
  PRICE_ALERT_MANAGEMENT_DUPLICATED_PRICE_ALERT = 'price-alert-management-duplicated-price-alert',
  PRICE_ALERT_MANAGEMENT_PRICE_ALERT_LIMIT_REACHED = 'price-alert-management-price-alert-limit-reached',
  PRICE_ALERT_MANAGEMENT_SYMBOL_TEMPORARILY_DISABLED = 'price-alert-management-symbol-temporarily-disabled',
  COPY_TRADE_STRATEGY_DETAILS_OPEN_POSITIONS = 'copy-trade-strategy-details-open-positions',
  COPY_TRADE_STRATEGY_DETAILS_HISTORY = 'copy-trade-strategy-details-history',

  COPY_TRADE_OPEN_COLUMN_OPEN_DATE = 'copy-trade-open-column-open-date',
  COPY_TRADE_OPEN_COLUMN_TRADE_ID = 'copy-trade-open-column-trade-id',
  COPY_TRADE_OPEN_COLUMN_STRATEGY_TYPE = 'copy-trade-open-column-strategy-type',
  COPY_TRADE_OPEN_COLUMN_SIGNAL = 'copy-trade-open-column-signal',
  COPY_TRADE_OPEN_COLUMN_PROFIT = 'copy-trade-open-column-profit',
  COPY_TRADE_OPEN_COLUMN_VOLUME = 'copy-trade-open-column-volume',
  COPY_TRADE_OPEN_COLUMN_UNITS = 'copy-trade-open-column-units',
  COPY_TRADE_OPEN_COLUMN_ENTRY_PRICE = 'copy-trade-open-column-entry-price',
  COPY_TRADE_OPEN_COLUMN_CLOSE_PRICE = 'copy-trade-open-column-close-price',
  COPY_TRADE_OPEN_COLUMN_TAKE_PROFIT = 'copy-trade-open-column-take-profit',
  COPY_TRADE_OPEN_COLUMN_STOP_LOSS = 'copy-trade-open-column-stop-loss',

  COPY_TRADE_HISTORY_COLUMN_OPEN_DATE = 'copy-trade-history-column-open-date',
  COPY_TRADE_HISTORY_COLUMN_CLOSE_DATE = 'copy-trade-history-column-close-date',
  COPY_TRADE_HISTORY_COLUMN_TRADE_ID = 'copy-trade-history-column-trade-id',
  COPY_TRADE_HISTORY_COLUMN_STRATEGY_TYPE = 'copy-trade-history-column-strategy-type',
  COPY_TRADE_HISTORY_COLUMN_SIGNAL = 'copy-trade-history-column-signal',
  COPY_TRADE_HISTORY_COLUMN_PROFIT = 'copy-trade-history-column-profit',
  COPY_TRADE_HISTORY_COLUMN_VOLUME = 'copy-trade-history-column-volume',
  COPY_TRADE_HISTORY_COLUMN_UNITS = 'copy-trade-history-column-units',
  COPY_TRADE_HISTORY_COLUMN_ENTRY_PRICE = 'copy-trade-history-column-entry-price',
  COPY_TRADE_HISTORY_COLUMN_CLOSE_PRICE = 'copy-trade-history-column-close-price',
  COPY_TRADE_HISTORY_COLUMN_TAKE_PROFIT = 'copy-trade-history-column-take-profit',
  COPY_TRADE_HISTORY_COLUMN_STOP_LOSS = 'copy-trade-history-column-stop-loss',
  COPY_TRADE_HISTORY_COLUMN_SWAP = 'copy-trade-history-column-swap',
  COPY_TRADE_HISTORY_COLUMN_COMMISSION = 'copy-trade-history-column-commission',
  COPY_TRADE_HISTORY_COLUMN_REMARK = 'copy-trade-history-column-remark',
  COPY_TRADE_HISTORY_COLUMN_COMMENT = 'copy-trade-history-column-comment',
  COPY_TRADE_TAB_ASSET_ORDER_TYPE_COPY_TRADE_MISSED_TRADES = 'copy-trade-tab-asset-order-type-copy-trade-missed-trades',
  COPY_TRADE_TAB_ASSET_ORDER_TYPE_COPY_TRADE_PROFILE = 'copy-trade-tab-asset-order-type-copy-trade-profile',

  COPIER_DRAWDOWN = 'copier-drawdown',
  COPIER_DRAWDOWN_INFO_BUTTON = 'copier-drawdown-info-button',
  COPIER_DRAWDOWN_SOFT_STOP_LEVEL_INFO_BUTTON = 'copier-drawdown-soft-stop-level-info-button',
  COPIER_DRAWDOWN_HARD_STOP_LEVEL_INFO_BUTTON = 'copier-drawdown-hard-stop-level-info-button',
  COPIER_DRAWDOWN_EDIT_BUTTON = 'copier-drawdown-edit-button',
  EDIT_COPIER_DRAWDOWN_CURRENT_LEVEL = 'edit-copier-drawdown-current-level',
  EDIT_COPIER_DRAWDOWN_RESET_BUTTON = 'edit-copier-drawdown-reset-button',
  EDIT_COPIER_DRAWDOWN_SOFT_STOP_LEVEL_INPUT = 'edit-copier-drawdown-soft-stop-level-input',
  EDIT_COPIER_DRAWDOWN_HARD_STOP_LEVEL_INPUT = 'edit-copier-drawdown-hard-stop-level-input',
  EDIT_COPIER_DRAWDOWN_SIGNAL_DRAWDOWN_TERMS_LINK = 'edit-copier-drawdown-signal-drawdown-terms-link',
  EDIT_COPIER_DRAWDOWN_AGREE_AND_CONFIRM_BUTTON = 'edit-copier-drawdown-agree-and-confirm-button',
  NO_COPY_TRADE_ACCOUNT_FOUND_MODAL = 'no-copy-trade-account-found-modal',

  COPY_TRADE_ICON_BUTTON = 'copy-trade-icon-button',
  COPY_TRADE_ICON_BOTTOM_SHEET = 'copy-trade-icon-bottom-sheet',
  COPY_TRADE_AUTH_LOGIN = 'copy-trade-auth-login',
  COPY_TRADE_AUTH_SIGNUP = 'copy-trade-auth-signup',
  COPY_TRADE_AUTH_FORGOT_PASSWORD = 'copy-trade-auth-forgot-password',
  COPY_TRADE_SECTION_SETTINGS = 'copy-trade-section-settings',
  COPY_TRADE_STRATEGY_SEARCH = 'copy-trade-strategy-search',
  COPY_TRADE_PROFILE = 'copy-trade-profile',
  COPY_TRADE_PROFILE_TAB_STATISTICS = 'copy-trade-profile-tab-statistics',
  COPY_TRADE_PROFILE_TAB_RETURN_HISTORY_CHART = 'copy-trade-profile-tab-return-history-chart',
  COPY_TRADE_LINK_ACCOUNT_BUTTON = 'copy-trade-link-account-button',

  COPY_TRADE_LINK_ACCOUNT_SERVER_CODE_FORM_ITEM = 'copy-trade-link-account-server-code-form-item',
  COPY_TRADE_LINK_ACCOUNT_SERVER_CODE_SELECT = 'copy-trade-link-account-server-code-select',
  COPY_TRADE_LINK_ACCOUNT_USERNAME_FORM_ITEM = 'copy-trade-link-account-username-form-item',
  COPY_TRADE_LINK_ACCOUNT_USERNAME_INPUT = 'copy-trade-link-account-username-input',
  COPY_TRADE_LINK_ACCOUNT_PASSWORD_FORM_ITEM = 'copy-trade-link-account-password-form-item',
  COPY_TRADE_LINK_ACCOUNT_PASSWORD_INPUT = 'copy-trade-link-account-password-input',
  COPY_TRADE_LINK_ACCOUNT_DATA_SHARING_FORM_ITEM = 'copy-trade-link-account-data-sharing-form-item',
  COPY_TRADE_LINK_ACCOUNT_DATA_SHARING_CHECKBOX = 'copy-trade-link-account-data-sharing-checkbox',
  COPY_TRADE_LINK_ACCOUNT_DATA_SHARING_ERROR = 'copy-trade-link-account-data-sharing-error',
  COPY_TRADE_LINK_ACCOUNT_SUBMIT_BUTTON = 'copy-trade-link-account-submit-button',
  COPY_TRADE_SWITCH_ACCOUNT_BUTTON = 'copy-trade-switch-account-button',
  COPY_TRADE_SELECT_ACCOUNT_BUTTON = 'copy-trade-select-account-button',
  SELECT_ACCOUNT_BOTTOM_SHEET = 'select-account-bottom-sheet',
  COPY_TRADE_EDIT_STRATEGY_BUTTON = 'copy-trade-edit-strategy-button',
  COPY_TRADE_COPY_STRATEGY_BUTTON = 'copy-trade-copy-strategy-button',
  COPY_TRADE_STRATEGY_PROFITABILITY_SECTION = 'copy-trade-strategy-profitability-section',
  COPY_TRADE_STRATEGY_PROFITABILITY_INFO = 'copy-trade-strategy-profitability-info',
  COPY_TRADE_STRATEGY_COPIERS_PROFIT_SECTION = 'copy-trade-strategy-copiers-profit-section',
  COPY_TRADE_STRATEGY_COPIERS_AUM_SECTION = 'copy-trade-strategy-copiers-aum-section',
  COPY_TRADE_STRATEGY_TRADES_SECTION = 'copy-trade-strategy-trades-section',
  COPY_TRADE_STRATEGY_MARKETS_TRADED_SECTION = 'copy-trade-strategy-markets-traded-section',
  COPY_TRADE_SWITCH_ACCOUNT_CONFIRM_MODAL = 'copy-trade-switch-account-confirm-modal',
  COPY_TRADE_EDIT_ACCOUNT_BUTTON = 'copy-trade-edit-account-button',
  COPY_TRADE_LANDSCAPE_BACK_BUTTON = 'copy-trade-landscape-back-button',
  COPY_TRADE_TIMEFRAME_OPTION = 'copy-trade-timeframe-option',
  COPY_TRADE_RETURN_HISTORY_EMPTY = 'copy-trade-return-history-empty',
  COPY_TRADE_SEARCH_INPUT = 'copy-trade-search-input',
  COPY_TRADE_SEARCH_CANCEL = 'copy-trade-search-cancel',
  COPY_TRADE_SEARCH_CLEAR = 'copy-trade-search-clear',
  COPY_TRADE_SEARCH_HISTORY_DELETE = 'copy-trade-search-history-delete',
  COPY_TRADE_SEARCH_HISTORY_TAG = 'copy-trade-search-history-tag',
  COPY_TRADE_SEARCH_RESULT_ITEM = 'copy-trade-search-result-item',
  COPY_TRADE_SEARCH_EMPTY = 'copy-trade-search-empty',
  COPY_TRADE_CLOSE_CONFIRMATION_MODAL = 'copy-trade-close-confirmation-modal',
  COPY_TRADE_EXPRESS_INTEREST_BUTTON = 'copy-trade-express-interest-button',
  COPY_TRADE_EXPRESS_INTEREST_MODAL = 'copy-trade-express-interest-modal',
  COPY_TRADE_LOCKED_OVERLAY = 'copy-trade-locked-overlay',

  COPY_TRADE_STOP_COPY_TRADE_MODAL = 'copy-trade-stop-copy-trade-modal',
  COPY_TRADE_STOP_COPY_TRADE_CONFIRM_BUTTON = 'copy-trade-stop-copy-trade-confirm-button',
  COPY_TRADE_STOP_COPY_TRADE_CANCEL_BUTTON = 'copy-trade-stop-copy-trade-cancel-button',

  COPY_TRADE_AUTHORIZATION_MODAL = 'copy-trade-authorization-modal',
  COPY_TRADE_AUTHORIZATION_STATEMENT_CHECKBOX = 'copy-trade-authorization-statement-checkbox',
  COPY_TRADE_AUTHORIZATION_TERMS_CHECKBOX = 'copy-trade-authorization-terms-checkbox',
  COPY_TRADE_AUTHORIZATION_STAST_LINK = 'copy-trade-authorization-stast-link',
  COPY_TRADE_AUTHORIZATION_CONFIRM_BUTTON = 'copy-trade-authorization-confirm-button',
  COPY_TRADE_AUTHORIZATION_CANCEL_BUTTON = 'copy-trade-authorization-cancel-button',

  COPY_TRADE_LEVERAGE_WARNING_MODAL = 'copy-trade-leverage-warning-modal',
  COPY_TRADE_CONFIRMATION_MODAL = 'copy-trade-confirmation-modal',

  COPY_TRADE_TRADE_SIZE_BOTTOM_SHEET = 'copy-trade-trade-size-bottom-sheet',
  COPY_TRADE_TRADE_SIZE_INFO_BUTTON = 'copy-trade-trade-size-info-button',
  COPY_TRADE_TRADE_SIZE_OPTION_FIXED = 'copy-trade-trade-size-option-fixed',
  COPY_TRADE_TRADE_SIZE_OPTION_MIRROR_SIZE = 'copy-trade-trade-size-option-mirror-size',
  COPY_TRADE_TRADE_SIZE_OPTION_MIRROR_RISK_BY_EQUITY = 'copy-trade-trade-size-option-mirror-risk-by-equity',
  COPY_TRADE_TRADE_SIZE_OPTION_MIRROR_RISK_BY_BALANCE = 'copy-trade-trade-size-option-mirror-risk-by-balance',

  COPY_TRADE_CENT_ACCOUNT_WARNING = 'copy-trade-cent-account-warning',

  COPY_TRADE_CONFIGURATION_SCREEN = 'copy-trade-configuration-screen',
  COPY_TRADE_CONFIGURATION_PERFORMANCE_FEE = 'copy-trade-configuration-performance-fee',
  COPY_TRADE_CONFIGURATION_PERFORMANCE_FEE_INFO = 'copy-trade-configuration-performance-fee-info',
  COPY_TRADE_CONFIGURATION_TRADE_SIZE_DROPDOWN = 'copy-trade-configuration-trade-size-dropdown',
  COPY_TRADE_CONFIGURATION_TRADE_SIZE_INFO = 'copy-trade-configuration-trade-size-info',
  COPY_TRADE_CONFIGURATION_TRADE_SIZE_VALUE_INPUT = 'copy-trade-configuration-trade-size-value-input',
  COPY_TRADE_CONFIGURATION_ROUND_UP_CHECKBOX = 'copy-trade-configuration-round-up-checkbox',
  COPY_TRADE_CONFIGURATION_COPY_EXISTING_CHECKBOX = 'copy-trade-configuration-copy-existing-checkbox',
  COPY_TRADE_CONFIGURATION_LEGAL_AGREEMENT = 'copy-trade-configuration-legal-agreement',
  COPY_TRADE_CONFIGURATION_SUBMIT_BUTTON = 'copy-trade-configuration-submit-button',
  COPY_TRADE_CONFIGURATION_CLOSE_BUTTON = 'copy-trade-configuration-close-button',

  COPY_TRADE_STRATEGY_LIST_TABS_SCREEN = 'copy-trade-strategy-list-tabs-screen',
  COPY_TRADE_STRATEGY_LIST_TABS_SHOW_ALL = 'copy-trade-strategy-list-tabs-show-all',
  COPY_TRADE_STRATEGY_LIST_TABS_ITEM_CHECKBOX = 'copy-trade-strategy-list-tabs-item-checkbox',
  COPY_TRADE_STRATEGY_LIST_TABS_ITEM_DRAG_HANDLE = 'copy-trade-strategy-list-tabs-item-drag-handle',
  COPY_TRADE_STRATEGY_LIST_TABS_SORTABLE = 'copy-trade-strategy-list-tabs-sortable',
  COPY_TRADE_STRATEGY_LIST_TABS_APPLY_BUTTON = 'copy-trade-strategy-list-tabs-apply-button',
  COPY_TRADE_STRATEGY_LIST_TABS_RESET_BUTTON = 'copy-trade-strategy-list-tabs-reset-button',

  COPY_TRADE_EMPTY_BROWSE_STRATEGIES_BUTTON = 'copy-trade-empty-browse-strategies-button',
  COPY_TRADE_EMPTY_LINK_ACCOUNT_BUTTON = 'copy-trade-empty-link-account-button'
}
